import React, { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/authcontext'
import { insertComplaint, insertCompliance, getComplaintsByTenantId, GetComplianceByTenant, getWeeklyFoodMenu, tenantNoticeInsert, getTenantNoticeByAdmission } from '../apis/services/pgApi'
import ProfileDrawer from './profiledrawer'

// ─── Constants ────────────────────────────────────────────────────
const COMPLAINT_CATS = [
  'Water Leakage', 'WiFi Issue', 'AC Not Working', 'Noisy Neighbours', 'Housekeeping',
  'Door Lock', 'Plumbing', 'Electricity', 'Security', 'Pest Control', 'Furniture',
  'Geyser/Hot Water', 'Laundry', 'Food Quality', 'Cleanliness', 'Fan', 'Drainage', 'Other',
]

// ─── SVG Icons ───────────────────────────────────────────────────
const Icon = {
  rupee: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="1.5" strokeLinecap="round"><path d="M12.9494914,6 C13.4853936,6.52514205 13.8531598,7.2212202 13.9645556,8 L17.5,8 C17.7761424,8 18,8.22385763 18,8.5 C18,8.77614237 17.7761424,9 17.5,9 L13.9645556,9 C13.7219407,10.6961471 12.263236,12 10.5,12 L7.70710678,12 L13.8535534,18.1464466 C14.0488155,18.3417088 14.0488155,18.6582912 13.8535534,18.8535534 C13.6582912,19.0488155 13.3417088,19.0488155 13.1464466,18.8535534 L6.14644661,11.8535534 C5.83146418,11.538571 6.05454757,11 6.5,11 L10.5,11 C11.709479,11 12.7183558,10.1411202 12.9499909,9 L6.5,9 C6.22385763,9 6,8.77614237 6,8.5 C6,8.22385763 6.22385763,8 6.5,8 L12.9499909,8 C12.7183558,6.85887984 11.709479,6 10.5,6 L6.5,6 C6.22385763,6 6,5.77614237 6,5.5 C6,5.22385763 6.22385763,5 6.5,5 L10.5,5 L17.5,5 C17.7761424,5 18,5.22385763 18,5.5 C18,5.77614237 17.7761424,6 17.5,6 L12.9494914,6 L12.9494914,6 Z" /></svg>,
  bell: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" /></svg>,
  logout: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" /></svg>,
  calendar: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>,
  chat: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /></svg>,
  alert: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>,
  visitor: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" /></svg>,
  complaint: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>,
  doc: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>,
  chevDown: <svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M3 5L7 9L11 5" stroke="#F06E18" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  close: <svg width="14" height="14" viewBox="0 0 18 18" fill="none"><path d="M1 1L17 17M17 1L1 17" stroke="#F06E18" strokeWidth="2" strokeLinecap="round" /></svg>,
  edit: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>,
  check: <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6L5 9L10 3" stroke="#F06E18" strokeWidth="2" strokeLinecap="round" /></svg>,
  phone: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.5 19.79 19.79 0 01.4.84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg>,
  mail: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>,
  shield: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>,
  building: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg>,
  bed: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M2 4v16M2 8h18a2 2 0 012 2v8M2 16h20" /></svg>,
  pin: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>,
  fork: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="2" x2="12" y2="22" /><path d="M17 5H9.5a3.5 3.5 0 000 7h5" /></svg>,
  person: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
  company: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><rect x="2" y="7" width="20" height="14" rx="1" /><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" /></svg>,
  download: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" /></svg>,
}

// ─── Helper Functions ────────────────────────────────────────────────
const formatDate = (dateString) => {
  if (!dateString) return '—'
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

const getMonthYear = (dateString) => {
  if (!dateString) return 'Unknown'
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
}

const getTodayDateOnly = () => {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  return d
}

const addDays = (date, days) => {
  const d = new Date(date)
  d.setDate(d.getDate() + days)
  return d
}

const toDateInputValue = (date) => date.toISOString().split('T')[0]

// ─── Notice Helper Functions ────────────────────────────────────────
const calculateTotalNoticeDays = (noticeDate, vacateDate) => {
  if (!noticeDate || !vacateDate) return null;
  const notice = new Date(noticeDate);
  const vacate = new Date(vacateDate);
  notice.setHours(0, 0, 0, 0);
  vacate.setHours(0, 0, 0, 0);
  const diffTime = vacate.getTime() - notice.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

const calculateRemainingDays = (vacateDate) => {
  if (!vacateDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const vacate = new Date(vacateDate);
  vacate.setHours(0, 0, 0, 0);
  const diffTime = vacate.getTime() - today.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

// ─── Modal wrapper ────────────────────────────────────────────────
const Modal = ({ title, onClose, children, footer }) => (
  <div className="td-modal-overlay" >
    <div className="td-modal" onClick={e => e.stopPropagation()}>
      <div className="td-modal-head">
        <h3 className="td-modal-title">{title}</h3>
        <button className="td-modal-close" onClick={onClose}>{Icon.close}</button>
      </div>
      <div className="td-modal-body">{children}</div>
      {footer && <div className="td-modal-footer">{footer}</div>}
    </div>
  </div>
)

// ─── Success Modal ────────────────────────────────────────────────────
const SuccessModal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null
  
  return (
    <div className="td-success-overlay">
      <div className="td-success-modal" onClick={e => e.stopPropagation()}>
        <div className="td-success-icon-wrapper">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12L11 15L16 9" />
          </svg>
        </div>
        <h3 className="td-success-title">{title}</h3>
        <p className="td-success-message">{message}</p>
        <div className="td-success-footer">
          <button className="td-success-btn" onClick={onClose}>Got it</button>
        </div>
      </div>
    </div>
  )
}

// ─── Error Modal ────────────────────────────────────────────────────
const ErrorModal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null
  
  return (
    <div className="td-error-overlay">
      <div className="td-error-modal" onClick={e => e.stopPropagation()}>
        <div className="td-error-icon-wrapper">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h3 className="td-error-title">{title}</h3>
        <p className="td-error-message">{message}</p>
        <div className="td-error-footer">
          <button className="td-error-btn" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  )
}

// ─── Coming Soon Modal ───────────────────────────────────────────────
const ComingSoonModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null
  
  return (
    <div className="td-comingsoon-overlay">
      <div className="td-comingsoon-modal" onClick={e => e.stopPropagation()}>
        <div className="td-comingsoon-icon-wrapper">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2">
            <path d="M12 8v4l3 3M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
          </svg>
        </div>
        <h3 className="td-comingsoon-title">Coming Soon!</h3>
        <p className="td-comingsoon-message">This feature is currently under development and will be available soon. Stay tuned!</p>
        <div className="td-comingsoon-footer">
          <button className="td-comingsoon-btn" onClick={onClose}>Got it</button>
        </div>
      </div>
    </div>
  )
}

// ─── Logout Confirmation Modal ────────────────────────────────────
const LogoutConfirmationModal = ({ onClose, onConfirm }) => {
  return (
    <div className="td-logout-overlay" >
      <div className="td-logout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="td-logout-modal-header">
          <div className="td-logout-icon-wrapper">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
            </svg>
          </div>
        </div>
        <div className="td-logout-modal-body">
          <h3 className="td-logout-modal-title">Confirm Logout</h3>
          <p className="td-logout-modal-message">Are you sure you want to log out? You will need to log in again to access your account.</p>
        </div>
        <div className="td-logout-modal-footer">
          <button className="td-logout-btn-cancel" onClick={onClose}>Cancel</button>
          <button className="td-logout-btn-confirm" onClick={onConfirm}>Logout</button>
        </div>
      </div>
    </div>
  )
}

// ─── No PG Linked Warning Modal ────────────────────────────────────────────
const NoPGLinkedModal = ({ onClose }) => {
  return (
    <div className="td-logout-overlay" >
      <div className="td-logout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="td-logout-modal-header">
          <div className="td-no-pg-icon-wrapper">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>
        <div className="td-logout-modal-body">
          <h3 className="td-logout-modal-title">No PG Linked</h3>
          <p className="td-logout-modal-message">You are not linked to any PG yet. Please contact your PG owner to get registered. Once linked, your dashboard will show all the details.</p>
        </div>
        <div className="td-logout-modal-footer">
          <button className="td-logout-btn-confirm" onClick={onClose}>Got it</button>
        </div>
      </div>
    </div>
  )
}

// ─── Security Deposit Deduction Confirmation Modal ────────────────
const SecurityDeductionConfirmModal = ({ onClose, onConfirm, vacateDate, isSubmitting = false }) => {
  return (
    <div className="td-logout-overlay">
      <div className="td-logout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="td-logout-modal-header">
          <div className="td-warn-icon-wrapper">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" fill="currentColor" />
              <rect x="11" y="8.25" width="2" height="6" rx="1" fill="#FFFBEB" />
              <circle cx="12" cy="17" r="1.15" fill="#FFFBEB" />
            </svg>
          </div>
        </div>
        <div className="td-logout-modal-body">
          <h3 className="td-logout-modal-title">Security Deposit Deduction</h3>
          <p className="td-logout-modal-message">
            Vacating on {vacateDate} is earlier than your standard notice period. As per your PG's short-notice policy, an applicable amount will be deducted from your security deposit. Do you want to proceed?
          </p>
        </div>
        <div className="td-logout-modal-footer">
          <button 
            className="td-logout-btn-cancel" 
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button 
            className="td-logout-btn-confirm td-warn-confirm-btn" 
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Processing...' : 'Yes, I Understand'}
          </button>
        </div>
      </div>
    </div>
  )
}

// ─── Complaint Modal with Validations ──────────────────────────────────────────────

const ComplaintModal = ({ onClose, onSubmit, tenantId, pgId, currentPG }) => {
  const [cat, setCat] = useState('')
  const [desc, setDesc] = useState('')
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const validateCategory = (value) => {
    if (!value) return 'Please select a category'
    return ''
  }

  const validateDescription = (value) => {
    if (!value || !value.trim()) return 'Description is required'
    if (value.length < 10) return 'Please provide more detail (minimum 10 characters)'
    if (value.length > 500) return 'Description must be less than 500 characters'
    return ''
  }

  const handleCategoryChange = (value) => {
    setCat(value)
    const error = validateCategory(value)
    setErrors(prev => ({ ...prev, cat: error }))
  }

  const handleDescChange = (value) => {
    setDesc(value)
    const error = validateDescription(value)
    setErrors(prev => ({ ...prev, desc: error }))
  }

  const validateForm = () => {
    const newErrors = {}
    const catError = validateCategory(cat)
    if (catError) newErrors.cat = catError
    const descError = validateDescription(desc)
    if (descError) newErrors.desc = descError
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const submit = async () => {
    if (!validateForm()) return

    setLoading(true)
    try {
      const result = await insertComplaint({
        PGID: pgId,
        TenantID: tenantId,
        ComplaintText: `${cat}: ${desc.substring(0, 100)}`,
        ComplaintDate: new Date().toISOString(),
      })

      if (result && result.ComplaintID) {
        onSubmit({
          type: 'complaint',
          title: `${cat}: ${desc.substring(0, 50)}`,
          sub: cat,
          status: 'OPEN',
          date: new Date().toISOString()
        })
        onClose()
      } else {
        setErrorMessage(result?.Message || 'Failed to submit complaint. Please try again.')
        setShowErrorModal(true)
      }
    } catch (error) {
      console.error('Error submitting complaint:', error)
      setErrorMessage(error.message || 'Failed to submit complaint. Please try again.')
      setShowErrorModal(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Modal title="New Complaint" onClose={onClose}
        footer={<>
          <button className="td-btn td-btn-outline" onClick={onClose}>Cancel</button>
          <button className="td-btn td-btn-primary" onClick={submit} disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </>}>
        <div className="td-form-grid">
          <div className="td-field td-field-half">
            <label className="td-label">Category <span className="td-req">*</span></label>
            <select 
              className={`td-select ${errors.cat ? 'td-input-err' : ''}`} 
              value={cat} 
              onChange={e => handleCategoryChange(e.target.value)}
            >
              <option value="">Select category</option>
              {COMPLAINT_CATS.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            {errors.cat && <span className="td-err">{errors.cat}</span>}
          </div>
          <div className="td-field td-field-full">
            <label className="td-label">Description <span className="td-req">*</span></label>
            <textarea 
              className={`td-textarea ${errors.desc ? 'td-input-err' : ''}`} 
              rows={3}
              placeholder="Describe your issue in detail (minimum 10 characters)..."
              value={desc}
              maxLength={500}
              onChange={e => handleDescChange(e.target.value)} 
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#9CA3AF', marginTop: '4px' }}>
              <span>{desc.length}/500 characters</span>
              {desc && desc.length < 10 && desc.length > 0 && (
                <span style={{ color: '#F59E0B' }}>Please add more detail (min 10 chars)</span>
              )}
            </div>
            {errors.desc && <span className="td-err">{errors.desc}</span>}
          </div>
        </div>
      </Modal>
      
      <ErrorModal 
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        title="Submission Failed"
        message={errorMessage}
      />
    </>
  )
}

// ─── Check In/Out Modal with Validations ────────────────────────────
const CheckInOutModal = ({ onClose, onSubmit, tenantId, pgId, currentPG }) => {
  const [reqType, setReqType] = useState('Check Out')
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const [contact, setContact] = useState('')
  const [reason, setReason] = useState('')
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const validateFromDate = (date) => {
    if (!date) return 'From date is required'
    const fromDate = new Date(date)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    if (fromDate < today) return 'From date cannot be in the past'
    return ''
  }

  const validateToDate = (toDate, fromDate) => {
    if (!toDate) return 'To date is required'
    const toDateObj = new Date(toDate)
    const fromDateObj = new Date(fromDate)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    
    if (toDateObj < today) return 'To date cannot be in the past'
    if (fromDate && toDateObj < fromDateObj) return 'To date must be after from date'
    return ''
  }

  const validateContact = (phone) => {
    if (phone && phone.trim()) {
      const phoneRegex = /^[0-9]{10}$/
      if (!phoneRegex.test(phone.trim())) return 'Emergency contact must be exactly 10 digits'
    }
    return ''
  }

  const validateReason = (text) => {
    if (text && text.trim()) {
      if (text.length < 5) return 'Please provide a more detailed reason (min 5 characters)'
      if (text.length > 500) return 'Reason must be less than 500 characters'
    }
    return ''
  }

  const handleFromChange = (value) => {
    setFrom(value)
    const error = validateFromDate(value)
    setErrors(prev => ({ ...prev, from: error }))
    if (to) {
      const toError = validateToDate(to, value)
      setErrors(prev => ({ ...prev, to: toError }))
    }
  }

  const handleToChange = (value) => {
    setTo(value)
    const error = validateToDate(value, from)
    setErrors(prev => ({ ...prev, to: error }))
  }

  const handleContactChange = (value) => {
    const cleaned = value.replace(/[^0-9]/g, '').slice(0, 10)
    setContact(cleaned)
    const error = validateContact(cleaned)
    setErrors(prev => ({ ...prev, contact: error }))
  }

  const handleReasonChange = (value) => {
    setReason(value)
    const error = validateReason(value)
    setErrors(prev => ({ ...prev, reason: error }))
  }

  const days = from && to && !errors.from && !errors.to 
    ? Math.max(0, Math.round((new Date(to) - new Date(from)) / 86400000))
    : null

  const validateForm = () => {
    const newErrors = {}
    const fromError = validateFromDate(from)
    if (fromError) newErrors.from = fromError
    const toError = validateToDate(to, from)
    if (toError) newErrors.to = toError
    const contactError = validateContact(contact)
    if (contactError) newErrors.contact = contactError
    const reasonError = validateReason(reason)
    if (reasonError) newErrors.reason = reasonError
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const submit = async () => {
    if (!validateForm()) return

    setLoading(true)
    try {
      const userId = parseInt(currentPG.nUserId || '0')

      const result = await insertCompliance({
        PGID: pgId,
        TenantID: tenantId,
        ComplianceType: reqType === 'Check Out' ? 'Check-Out' : 'Check-In',
        ComplianceDetails: reason || `${reqType} request from ${from} to ${to}`,
        DateRange: `${from} to ${to}`,
        ActionTaken: null,
        Status: 'PENDING',
        UserId: userId
      })

      if (result && result.Success === 1) {
        onSubmit({
          type: 'checkinout',
          title: `${reqType} Request`,
          sub: `${from} → ${to}`,
          status: 'PENDING',
          date: new Date().toISOString()
        })
        onClose()
      } else {
        setErrorMessage(result?.Message || 'Failed to submit request')
        setShowErrorModal(true)
      }
    } catch (error) {
      console.error('Error submitting request:', error)
      setErrorMessage('Failed to submit request. Please try again.')
      setShowErrorModal(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Modal title="New Check In / Check Out Request" onClose={onClose}
        footer={<>
          <button className="td-btn td-btn-outline" onClick={onClose}>Cancel</button>
          <button className="td-btn td-btn-primary" onClick={submit} disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </>}>
        <div className="td-form-grid">
          <div className="td-field td-field-half">
            <label className="td-label">Request Type <span className="td-req">*</span></label>
            <select className="td-select" value={reqType} onChange={e => setReqType(e.target.value)}>
              <option value="Check Out">Check Out</option>
              <option value="Check In">Check In</option>
            </select>
          </div>

          <div className="td-field td-field-half" data-error-field="from">
            <label className="td-label">From Date <span className="td-req">*</span></label>
            <input
              className={`td-input ${errors.from ? 'td-input-err' : ''}`}
              type="date"
              value={from}
              onChange={e => handleFromChange(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
            />
            {errors.from && <span className="td-err">{errors.from}</span>}
          </div>

          <div className="td-field td-field-half" data-error-field="to">
            <label className="td-label">To Date <span className="td-req">*</span></label>
            <input
              className={`td-input ${errors.to ? 'td-input-err' : ''}`}
              type="date"
              value={to}
              onChange={e => handleToChange(e.target.value)}
              min={from || new Date().toISOString().split('T')[0]}
            />
            {errors.to && <span className="td-err">{errors.to}</span>}
          </div>

          <div className="td-field td-field-half">
            <label className="td-label">Number of Days</label>
            <input 
              className="td-input td-input-ro" 
              readOnly 
              value={days !== null && !errors.from && !errors.to 
                ? `${days} day${days !== 1 ? 's' : ''}` 
                : '—'} 
            />
            {from && to && !errors.from && !errors.to && days === 0 && (
              <span className="td-err">Same day selected. This will be processed as a 1-day request</span>
            )}
          </div>

          <div className="td-field td-field-half" data-error-field="contact">
            <label className="td-label">Emergency Contact</label>
            <input
              className={`td-input ${errors.contact ? 'td-input-err' : ''}`}
              type="tel"
              placeholder="9999999999"
              value={contact}
              onChange={e => handleContactChange(e.target.value)}
            />
            <span className="td-hint">Optional, but recommended for emergency communication</span>
            {errors.contact && <span className="td-err">{errors.contact}</span>}
          </div>

          <div className="td-field td-field-full" data-error-field="reason">
            <label className="td-label">Reason</label>
            <textarea
              className={`td-textarea ${errors.reason ? 'td-input-err' : ''}`}
              placeholder="e.g., Family function, Medical emergency, Vacation, Business travel..."
              rows={3}
              maxLength={500}
              value={reason}
              onChange={e => handleReasonChange(e.target.value)}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#9CA3AF', marginTop: '4px' }}>
              <span>{reason.length}/500 characters</span>
              {reason && reason.length < 5 && reason.length > 0 && (
                <span style={{ color: '#F59E0B' }}>Please add more detail (min 5 chars)</span>
              )}
            </div>
            {errors.reason && <span className="td-err">{errors.reason}</span>}
          </div>
        </div>
      </Modal>

      <ErrorModal 
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        title="Submission Failed"
        message={errorMessage}
      />
    </>
  )
}

// ─── Visitor Modal with Validations ───────────────────────────────────
const VisitorModal = ({ onClose, onSubmit, tenantId, pgId, currentPG }) => {
  const [name, setName] = useState('')
  const [rel, setRel] = useState('')
  const [mobile, setMobile] = useState('')
  const [arrival, setArrival] = useState('')
  const [depart, setDepart] = useState('')
  const [notes, setNotes] = useState('')
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const validateName = (value) => {
    if (!value || !value.trim()) return 'Visitor name is required'
    if (value.length < 2) return 'Name must be at least 2 characters'
    if (value.length > 100) return 'Name must be less than 100 characters'
    if (!/^[a-zA-Z\s\-\.]+$/.test(value.trim())) return 'Name should only contain letters, spaces, hyphens, and dots'
    return ''
  }

  const validateRelation = (value) => {
    if (value && value.trim()) {
      if (value.length > 50) return 'Relation must be less than 50 characters'
      if (!/^[a-zA-Z\s\-\.]+$/.test(value.trim())) return 'Relation should only contain letters, spaces, hyphens, and dots'
    }
    return ''
  }

  const validateMobile = (value) => {
    if (!value || !value.trim()) return 'Mobile number is required'
    const phoneRegex = /^[0-9]{10}$/
    if (!phoneRegex.test(value.trim())) return 'Mobile number must be exactly 10 digits'
    return ''
  }

  const validateArrivalDate = (date) => {
    if (!date) return 'Arrival date is required'
    const arrivalDate = new Date(date)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    if (arrivalDate < today) return 'Arrival date cannot be in the past'
    return ''
  }

  const validateDepartureDate = (departDate, arrivalDate) => {
    if (departDate && departDate.trim()) {
      const departDateObj = new Date(departDate)
      const arrivalDateObj = new Date(arrivalDate)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      
      if (departDateObj < today) return 'Departure date cannot be in the past'
      if (arrivalDate && departDateObj < arrivalDateObj) return 'Departure date must be after arrival date'
      
      if (arrivalDate && (departDateObj - arrivalDateObj) / 86400000 > 30) {
        return 'Visitor stay cannot exceed 30 days'
      }
    }
    return ''
  }

  const validateNotes = (text) => {
    if (text && text.trim()) {
      if (text.length > 500) return 'Notes must be less than 500 characters'
    }
    return ''
  }

  const handleNameChange = (value) => {
    setName(value)
    const error = validateName(value)
    setErrors(prev => ({ ...prev, name: error }))
  }

  const handleRelationChange = (value) => {
    setRel(value)
    const error = validateRelation(value)
    setErrors(prev => ({ ...prev, relation: error }))
  }

  const handleMobileChange = (value) => {
    const cleaned = value.replace(/[^0-9]/g, '').slice(0, 10)
    setMobile(cleaned)
    const error = validateMobile(cleaned)
    setErrors(prev => ({ ...prev, mobile: error }))
  }

  const handleArrivalChange = (value) => {
    setArrival(value)
    const error = validateArrivalDate(value)
    setErrors(prev => ({ ...prev, arrival: error }))
    if (depart) {
      const departError = validateDepartureDate(depart, value)
      setErrors(prev => ({ ...prev, departure: departError }))
    }
  }

  const handleDepartureChange = (value) => {
    setDepart(value)
    const error = validateDepartureDate(value, arrival)
    setErrors(prev => ({ ...prev, departure: error }))
  }

  const handleNotesChange = (value) => {
    setNotes(value)
    const error = validateNotes(value)
    setErrors(prev => ({ ...prev, notes: error }))
  }

  const days = arrival && depart && !errors.arrival && !errors.departure
    ? Math.max(0, Math.round((new Date(depart) - new Date(arrival)) / 86400000))
    : null

  const validateForm = () => {
    const newErrors = {}
    const nameError = validateName(name)
    if (nameError) newErrors.name = nameError
    const relationError = validateRelation(rel)
    if (relationError) newErrors.relation = relationError
    const mobileError = validateMobile(mobile)
    if (mobileError) newErrors.mobile = mobileError
    const arrivalError = validateArrivalDate(arrival)
    if (arrivalError) newErrors.arrival = arrivalError
    const departureError = validateDepartureDate(depart, arrival)
    if (departureError) newErrors.departure = departureError
    const notesError = validateNotes(notes)
    if (notesError) newErrors.notes = notesError
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const submit = async () => {
    if (!validateForm()) return

    setLoading(true)
    try {
      const userId = parseInt(currentPG.nUserId || '0')

      const result = await insertCompliance({
        PGID: pgId,
        TenantID: tenantId,
        ComplianceType: 'Visitor',
        ComplianceDetails: `Visitor: ${name} (${rel || 'Guest'}) | Mobile: ${mobile} | Purpose: ${notes || 'Not specified'}`,
        DateRange: depart ? `${arrival} to ${depart}` : arrival,
        ActionTaken: null,
        Status: 'PENDING',
        UserId: userId
      })

      if (result && result.Success === 1) {
        onSubmit({
          type: 'visitor',
          title: `Visitor: ${name}`,
          sub: rel || 'Guest',
          status: 'PENDING',
          date: new Date().toISOString()
        })
        onClose()
      } else {
        setErrorMessage(result?.Message || 'Failed to submit visitor request')
        setShowErrorModal(true)
      }
    } catch (error) {
      console.error('Error submitting visitor:', error)
      setErrorMessage('Failed to submit visitor request. Please try again.')
      setShowErrorModal(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Modal title="New Visitor Request" onClose={onClose}
        footer={<>
          <button className="td-btn td-btn-outline" onClick={onClose}>Cancel</button>
          <button className="td-btn td-btn-primary" onClick={submit} disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </>}>
        <div className="td-form-grid">
          <div className="td-field td-field-half" data-error-field="name">
            <label className="td-label">Visitor Name <span className="td-req">*</span></label>
            <input
              className={`td-input ${errors.name ? 'td-input-err' : ''}`}
              type="text"
              placeholder="Full name"
              maxLength={100}
              value={name}
              onChange={e => handleNameChange(e.target.value)}
            />
            {errors.name && <span className="td-err">{errors.name}</span>}
          </div>

          <div className="td-field td-field-half" data-error-field="relation">
            <label className="td-label">Relation</label>
            <input
              className={`td-input ${errors.relation ? 'td-input-err' : ''}`}
              type="text"
              placeholder="e.g. Father, Mother, Friend, Colleague"
              maxLength={50}
              value={rel}
              onChange={e => handleRelationChange(e.target.value)}
            />
            {errors.relation && <span className="td-err">{errors.relation}</span>}
          </div>

          <div className="td-field td-field-half" data-error-field="mobile">
            <label className="td-label">Mobile Number <span className="td-req">*</span></label>
            <input
              className={`td-input ${errors.mobile ? 'td-input-err' : ''}`}
              type="tel"
              placeholder="9999999999"
              value={mobile}
              onChange={e => handleMobileChange(e.target.value)}
            />
            {errors.mobile && <span className="td-err">{errors.mobile}</span>}
          </div>

          <div className="td-field td-field-half" data-error-field="arrival">
            <label className="td-label">Arrival Date <span className="td-req">*</span></label>
            <input
              className={`td-input ${errors.arrival ? 'td-input-err' : ''}`}
              type="date"
              value={arrival}
              onChange={e => handleArrivalChange(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
            />
            {errors.arrival && <span className="td-err">{errors.arrival}</span>}
          </div>

          <div className="td-field td-field-half" data-error-field="departure">
            <label className="td-label">Departure Date</label>
            <input
              className={`td-input ${errors.departure ? 'td-input-err' : ''}`}
              type="date"
              value={depart}
              onChange={e => handleDepartureChange(e.target.value)}
              min={arrival || new Date().toISOString().split('T')[0]}
            />
            {errors.departure && <span className="td-err">{errors.departure}</span>}
            <span className="td-hint">Leave empty for day visit</span>
          </div>

          <div className="td-field td-field-half">
            <label className="td-label">Number of Days</label>
            <input
              className="td-input td-input-ro"
              readOnly
              value={days !== null && !errors.arrival && !errors.departure
                ? `${days} day${days !== 1 ? 's' : ''}`
                : arrival && !errors.arrival && !depart ? 'Day visit' : '—'}
            />
            {arrival && !depart && !errors.arrival && (
              <span className="td-hint" style={{ color: '#F59E0B' }}>No departure date set - day visit</span>
            )}
            {days === 0 && arrival && depart && !errors.arrival && !errors.departure && (
              <span className="td-hint" style={{ color: '#F59E0B' }}>Same day selected - day visit</span>
            )}
          </div>

          <div className="td-field td-field-full" data-error-field="notes">
            <label className="td-label">Purpose / Notes</label>
            <textarea
              className={`td-textarea ${errors.notes ? 'td-input-err' : ''}`}
              placeholder="Purpose of visit (e.g., Family function, Overnight stay, Weekend visit, Business meeting...)"
              rows={3}
              maxLength={500}
              value={notes}
              onChange={e => handleNotesChange(e.target.value)}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#9CA3AF', marginTop: '4px' }}>
              <span>{notes.length}/500 characters</span>
            </div>
            {errors.notes && <span className="td-err">{errors.notes}</span>}
          </div>
        </div>
      </Modal>

      <ErrorModal 
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        title="Submission Failed"
        message={errorMessage}
      />
    </>
  )
}

// ─── Agreement Modal ──────────────────────────────────────────────
const AgreementModal = ({ onClose, onComingSoon, currentPG }) => {
  return (
    <Modal title="Rental Agreement" onClose={onClose}
      footer={
        <button className="td-btn td-btn-primary" onClick={() => {
          onClose()
          onComingSoon()
        }}>
          {Icon.download} Download
        </button>
      }>
      <div className="td-agreement">
        <div className="td-agr-badge">
          <span className="td-agr-icon">{Icon.doc}</span>
          <div>
            <span className="td-agr-name">Rental Agreement</span>
            <span className="td-agr-status">● {currentPG.Status || 'Active'}</span>
          </div>
        </div>
        <div className="td-agr-grid">
          {[
            ['Tenant Name', currentPG.TenantName || '—'],
            ['PG Name', `${currentPG.PGName || 'PG'} (${currentPG.PGCode || '—'})`],
            ['Room / Bed', `${currentPG.RoomNumber || '—'} / ${currentPG.BedNumber || '—'}`],
            ['Floor', currentPG.Floor || '—'],
            ['Room Type', currentPG.RoomType || '—'],
            ['Start Date', currentPG.JoiningDate ? new Date(currentPG.JoiningDate).toLocaleDateString() : '—'],
            ['End Date', currentPG.CheckOutDate ? new Date(currentPG.CheckOutDate).toLocaleDateString() : 'Ongoing'],
            ['Rent Amount', `₹${(currentPG.NetPayable || currentPG.RentAmount || 0).toLocaleString()}/month`],
            ['Security Deposit', `₹${((currentPG.NetPayable || currentPG.RentAmount || 0) * 2).toLocaleString()}`],
            ['Agreement Status', currentPG.Status || 'Active'],
          ].map(([l, v]) => (
            <div key={l} className="td-agr-field">
              <span className="td-agr-label">{l}</span>
              <span className="td-agr-value">{v}</span>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}

// ─── Status Badge ─────────────────────────────────────────────────
const StatusBadge = ({ status }) => {
  const cfg = STATUS_CFG[status?.toUpperCase()] || STATUS_CFG.PENDING
  return (
    <span className="td-status-badge" style={{ background: cfg.bg, color: cfg.text, borderColor: cfg.border }}>
      <span className="td-status-dot" style={{ background: cfg.dot }} />
      {cfg.label}
    </span>
  )
}

// ─── Activity Icon ────────────────────────────────────────────────
const ActivityIcon = ({ type }) => {
  const cfg = TYPE_CFG[type]
  if (!cfg) return null
  return (
    <span className="td-act-icon" style={{ background: cfg.bg, color: cfg.color }}>
      {type === 'complaint' ? Icon.complaint : type === 'visitor' ? Icon.visitor : Icon.calendar}
    </span>
  )
}

// ─── Activity Accordion ───────────────────────────────────────────
const ActivityAccordion = ({ month, items, defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <div className="td-acc-item">
      <button className="td-acc-head" onClick={() => setOpen(p => !p)}>
        <span className="td-acc-month">{month} <span className="td-acc-count">({items.length})</span></span>
        <span className={`td-acc-chevron ${open ? 'open' : ''}`}>{Icon.chevDown}</span>
      </button>
      {open && (
        <div className="td-acc-body">
          {items.map((a, idx) => (
            <div key={idx} className="td-act-row">
              <ActivityIcon type={a.type} />
              <div className="td-act-info">
                <span className="td-act-title">{a.title}</span>
                <span className="td-act-meta">
                  <span className="td-act-type-pill" style={{ color: TYPE_CFG[a.type]?.color, background: TYPE_CFG[a.type]?.bg }}>
                    {TYPE_CFG[a.type]?.label}
                  </span>
                  · {a.sub} · {formatDate(a.date)}
                </span>
              </div>
              <StatusBadge status={a.status} />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// ─── Quick Action Card ────────────────────────────────────────────
const ActionCard = ({ icon, label, color, bg, onClick }) => (
  <button className="td-action-card" onClick={onClick}>
    <span className="td-action-icon" style={{ background: bg, color }}>{icon}</span>
    <span className="td-action-label">{label}</span>
  </button>
)

// ─── Stat Card ────────────────────────────────────────────────────
const StatCard = ({ icon, label, value, valueClass }) => (
  <div className="td-stat-card">
    <div className="td-stat-top">
      <span className="td-stat-icon-wrap">{icon}</span>
      <span className="td-stat-label">{label}</span>
    </div>
    <span className={`td-stat-value ${valueClass || ''}`}>{value}</span>
  </div>
)

// ─── STATUS_CFG and TYPE_CFG ──────────────────────────────────────
const STATUS_CFG = {
  PENDING: { label: 'Pending', bg: '#FFF7ED', text: '#C2410C', border: '#FED7AA', dot: '#F97316' },
  IN_PROGRESS: { label: 'In Progress', bg: '#EFF6FF', text: '#1D4ED8', border: '#BFDBFE', dot: '#3B82F6' },
  APPROVED: { label: 'Approved', bg: '#F0FDF4', text: '#166534', border: '#86EFAC', dot: '#22C55E' },
  RESOLVED: { label: 'Resolved', bg: '#F3F4F6', text: '#6B7280', border: '#E5E7EB', dot: '#9CA3AF' },
  COMPLETED: { label: 'Completed', bg: '#F0FDF4', text: '#166534', border: '#86EFAC', dot: '#22C55E' },
  REJECTED: { label: 'Rejected', bg: '#FFF1F2', text: '#991B1B', border: '#FECACA', dot: '#EF4444' },
  OPEN: { label: 'Open', bg: '#FFF7ED', text: '#C2410C', border: '#FED7AA', dot: '#F97316' },
}

const TYPE_CFG = {
  complaint: { label: 'Complaint', color: '#EF4444', bg: '#FFF1F2' },
  visitor: { label: 'Visitor', color: '#6366F1', bg: '#EEF2FF' },
  checkinout: { label: 'Check In/Out', color: '#0EA5E9', bg: '#F0F9FF' },
  noticeperiod: { label: 'Notice Period', color: '#D97706', bg: '#FFFBEB' },
}



// ─── Notice Period Modal ───────────────────────────────────────────
const NoticePeriodModal = ({ onClose, onSubmit, tenantId, pgId, currentPG }) => {
  const [noticeType, setNoticeType] = useState('standard')
  const [shortDate, setShortDate] = useState('')
  const [reason, setReason] = useState('')
  const [errors, setErrors] = useState({})
  const [showDeductionConfirm, setShowDeductionConfirm] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const noticePeriodDays = currentPG.NoticePeriodDays || currentPG.NoticePeriod || 30

  const getTodayDateStr = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const addDaysToDateStr = (dateStr, days) => {
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day + days);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const todayStr = getTodayDateStr();
  const standardDateStr = addDaysToDateStr(todayStr, noticePeriodDays);

  const formatDateDisplay = (dateStr) => {
    if (!dateStr) return 'N/A';
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const validateShortDate = (date) => {
    if (!date) return 'Please select a vacate date'
    const dateObj = new Date(date + 'T00:00:00')
    const todayObj = new Date(todayStr + 'T00:00:00')
    const standardObj = new Date(standardDateStr + 'T00:00:00')
    
    if (dateObj < todayObj) return 'Date cannot be in the past'
    if (dateObj > standardObj) return `Date must be within your ${noticePeriodDays}-day notice period`
    return ''
  }

  const handleShortDateChange = (value) => {
    setShortDate(value)
    setErrors(prev => ({ ...prev, shortDate: validateShortDate(value) }))
  }

  const submitRequest = async (vacateDateStr, isShort) => {
    if (currentPG.AdmissionId == null) {
      alert('Active admission not found. Please contact support.')
      return
    }
    setIsSubmitting(true)
    
    try {
      const noticeData = {
        AdmissionID: parseInt(currentPG.AdmissionId),
        PGID: parseInt(pgId),
        NoticeDate: todayStr,
        VacateDate: vacateDateStr,
        NoticeReason: reason || (isShort ? 'Short notice request' : 'Standard notice request')
      }
      console.log('currentPG.AdmissionId:', currentPG.AdmissionId)
      console.log('Submitting notice data:', noticeData)
      const response = await tenantNoticeInsert(noticeData)
      
      if (response && response.success) {
        onSubmit({
          type: 'noticeperiod',
          title: isShort ? 'Short Notice Period Request' : 'Notice Period Request',
          sub: `Vacate on ${formatDateDisplay(vacateDateStr)}`,
          status: 'PENDING',
          date: new Date().toISOString(),
          noticeId: response.data?.NoticeID || null
        })
        
        setShowDeductionConfirm(false)
        onClose()
        console.log('Notice submitted successfully:', response.message)
      }
    } catch (error) {
      console.error('Error submitting notice:', error)
      
      let errorMessage = 'Failed to submit notice request. Please try again.'
      
      if (error.message && error.message.includes('Active Admission not found')) {
        errorMessage = 'Active admission not found. Please contact support.'
      } else if (error.message && error.message.includes('Notice request already exists')) {
        errorMessage = 'A notice request already exists for this tenant. Please check your pending requests.'
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message
      }
      
      alert(errorMessage)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleSubmitClick = () => {
    if (noticeType === 'standard') {
      submitRequest(standardDateStr, false)
      return
    }
    const err = validateShortDate(shortDate)
    setErrors(prev => ({ ...prev, shortDate: err }))
    if (err) return
    setShowDeductionConfirm(true)
  }

  const handleConfirmDeduction = () => {
    submitRequest(shortDate, true)
  }

  return (
    <>
      <Modal
        title="Notice Period Request"
        onClose={onClose}
        footer={<>
          <button 
            className="td-btn td-btn-outline" 
            onClick={onClose} 
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            className="td-btn td-btn-primary"
            onClick={handleSubmitClick}
            disabled={isSubmitting || (noticeType === 'short' && !shortDate)}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </>}
      >
        <div className="td-toggle-group">
          <button
            type="button"
            className={`td-toggle-btn ${noticeType === 'standard' ? 'active' : ''}`}
            onClick={() => setNoticeType('standard')}
            disabled={isSubmitting}
          >
            Standard Notice
          </button>
          <button
            type="button"
            className={`td-toggle-btn ${noticeType === 'short' ? 'active' : ''}`}
            onClick={() => setNoticeType('short')}
            disabled={isSubmitting}
          >
            Short Notice
          </button>
        </div>

        {noticeType === 'standard' ? (
          <div className="td-notice-info-card">
            <span className="td-notice-info-icon">{Icon.calendar}</span>
            <div className="td-notice-info-text">
              <p className="td-notice-info-title">Your PG requires {noticePeriodDays} days' notice</p>
              <p className="td-notice-info-sub">
                Based on today, {formatDateDisplay(todayStr)}, your notice period will end on <strong>{formatDateDisplay(standardDateStr)}</strong>. This will be your vacate date.
              </p>
            </div>
          </div>
        ) : (
          <>
            <div className="td-field td-field-full" data-error-field="shortDate">
              <label className="td-label">Preferred Vacate Date <span className="td-req">*</span></label>
              <input
                className={`td-input ${errors.shortDate ? 'td-input-err' : ''}`}
                type="date"
                value={shortDate}
                min={todayStr}
                max={standardDateStr}
                onChange={e => handleShortDateChange(e.target.value)}
                disabled={isSubmitting}
              />
              <span className="td-hint">
                Select any date between {formatDateDisplay(todayStr)} and {formatDateDisplay(standardDateStr)}, as per your PG's notice period policy.
              </span>
              {errors.shortDate && <span className="td-err">{errors.shortDate}</span>}
            </div>

            <div className="td-notice-warning-banner">
              {Icon.alert}
              <span>Vacating before your standard notice period ends will result in a deduction from your security deposit.</span>
            </div>
          </>
        )}

        <div className="td-field td-field-full" style={{ marginTop: 14 }}>
          <label className="td-label">Reason (optional)</label>
          <textarea
            className="td-textarea"
            placeholder="e.g., Job relocation, personal reasons..."
            rows={3}
            maxLength={500}
            value={reason}
            onChange={e => setReason(e.target.value)}
            disabled={isSubmitting}
          />
        </div>
      </Modal>

      {showDeductionConfirm && (
        <SecurityDeductionConfirmModal
          onClose={() => setShowDeductionConfirm(false)}
          onConfirm={handleConfirmDeduction}
          vacateDate={formatDateDisplay(shortDate)}
          isSubmitting={isSubmitting}
        />
      )}
    </>
  )
}

// ─── Food Menu Modal (Read-Only) ────────────────────────────────────

const FoodMenuModal = ({ isOpen, onClose, selectedPG }) => {
  const [weekMenu, setWeekMenu] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen && selectedPG) {
      fetchWeeklyMenu();
    }
  }, [isOpen, selectedPG]);

  const fetchWeeklyMenu = async () => {
    if (!selectedPG?.PGID) return;

    setLoading(true);
    setError("");
    
    try {
      const today = getTodayIST();
      const response = await getWeeklyFoodMenu(selectedPG.PGID, today);
      console.log("Weekly menu response:", response);

      const todayDate = parseDate(today);
      const todayDow = todayDate.getDay();

      const mondayOffset = (todayDow === 0) ? -6 : 1 - todayDow;
      const mondayDate = new Date(todayDate);
      mondayDate.setDate(todayDate.getDate() + mondayOffset);

      const weekArray = [];
      const weekMap = {};

      for (let i = 0; i < 7; i++) {
        const date = new Date(mondayDate);
        date.setDate(mondayDate.getDate() + i);
        
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const dateStr = `${yyyy}-${mm}-${dd}`;
        const dayName = DAY_FULL[i];

        const dayData = {
          date: dateStr,
          day: DAY_ABBR[i],
          fullDay: dayName,
          isToday: dateStr === today,
          items: {
            breakfast: [],
            lunch: [],
            tea: [],
            dinner: [],
          }
        };

        weekArray.push(dayData);
        weekMap[dateStr] = dayData;
        weekMap[dayName] = dayData;
      }

      if (response && response.data && response.data.weeklyMenu) {
        const weeklyData = response.data.weeklyMenu;
        
        weeklyData.forEach((item) => {
          const dayName = item.dayName;
          const mealType = item.mealType.toLowerCase();
          const dayData = weekMap[dayName];
          
          if (dayData) {
            const items = [];
            if (item.item1) items.push(item.item1);
            if (item.item2) items.push(item.item2);
            if (item.item3) items.push(item.item3);
            if (item.item4) items.push(item.item4);
            
            let mealKey = mealType;
            if (mealType === 'breakfast') mealKey = 'breakfast';
            else if (mealType === 'lunch') mealKey = 'lunch';
            else if (mealType === 'tea') mealKey = 'tea';
            else if (mealType === 'dinner') mealKey = 'dinner';
            
            dayData.items[mealKey] = items;
          }
        });
      }

      setWeekMenu(weekArray);
    } catch (err) {
      console.error("Error fetching weekly menu:", err);
      setError("Failed to load weekly menu. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const formatDateToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    try {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return "";
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (e) {
      return "";
    }
  };

  const renderWeeklyTableView = () => (
    <div className="td-food-table-wrapper">
      <table className="td-food-table">
        <thead>
          <tr>
            <th className="td-food-meal-header">Meal</th>
            {weekMenu.map((day) => (
              <th key={day.date} className={day.isToday ? 'today' : ''}>
                <span className="td-food-th-day">{day.day}</span>
                {day.isToday ? (
                  <span className="td-today-badge">Today</span>
                ) : null}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[
            { key: 'breakfast', label: 'Breakfast', icon: '🌅' },
            { key: 'lunch', label: 'Lunch', icon: '☀️' },
            { key: 'tea', label: 'Tea', icon: '🍵' },
            { key: 'dinner', label: 'Dinner', icon: '🌙' },
          ].map((meal) => (
            <tr key={meal.key}>
              <td className="td-food-meal-label">
                <span>{meal.icon}</span> {meal.label}
              </td>
              {weekMenu.map((day) => (
                <td key={day.date} className={`td-food-cell ${day.isToday ? 'today' : ''}`}>
                  <div className="td-food-cell-inner">
                    {day.items?.[meal.key]?.length > 0 ? (
                      <ol className="td-food-items-list">
                        {day.items[meal.key].map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ol>
                    ) : (
                      <span className="td-food-empty">—</span>
                    )}
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderMobileCardView = () => (
    <div className="td-food-mobile">
      {weekMenu.map((day) => (
        <div key={day.date} className={`td-food-card ${day.isToday ? 'today' : ''}`}>
          <div className="td-food-card-header">
            <div>
              <span className="td-food-card-day">{day.day}</span>
              {day.isToday && <span className="td-today-badge">Today</span>}
            </div>
            <span className="td-food-card-date">{formatDateToDDMMYYYY(day.date)}</span>
          </div>
          <div className="td-food-card-body">
            {[
              { key: 'breakfast', label: 'Breakfast', icon: '🌅' },
              { key: 'lunch', label: 'Lunch', icon: '☀️' },
              { key: 'tea', label: 'Tea', icon: '🍵' },
              { key: 'dinner', label: 'Dinner', icon: '🌙' },
            ].map((meal) => (
              <div className="td-food-card-meal-row" key={meal.key}>
                <div className="td-food-card-meal-label">
                  <span>{meal.icon}</span> {meal.label}
                </div>
                <div className="td-food-card-meal-value">
                  {day.items?.[meal.key]?.length > 0 ? (
                    <ol className="td-food-items-list">
                      {day.items[meal.key].map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ol>
                  ) : (
                    <span className="td-food-empty">—</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="td-food-overlay" onClick={onClose}>
      <div className="td-food-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="td-food-modal-header">
          <div>
            <h3 className="td-food-modal-title">Weekly Food Menu</h3>
            <p className="td-food-modal-sub">{selectedPG?.PGName || "Weekly meal plan"}</p>
          </div>
          <button className="td-food-modal-close" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M1 1L17 17M17 1L1 17" stroke="#374151" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className="td-food-modal-body">
          <div className="td-food-toolbar">
            <span className="td-food-days-count">
              📅 Monday – Sunday · today's column is highlighted
            </span>
          </div>

          {loading && (
            <div className="td-food-loading">
              <div className="td-food-spinner"></div>
              <p>Loading menu...</p>
            </div>
          )}

          {error && (
            <p className="td-food-error">{error}</p>
          )}

          {!loading && !error && weekMenu.length > 0 && (
            <>
              <div className="td-food-desktop">
                {renderWeeklyTableView()}
              </div>
              <div className="td-food-mobile-view">
                {renderMobileCardView()}
              </div>
            </>
          )}

          {!loading && !error && weekMenu.length === 0 && (
            <div className="td-food-empty-state">
              <p>No menu items found for this week.</p>
            </div>
          )}
        </div>

        <div className="td-food-modal-footer">
          <button className="td-food-close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Helper function for today's date ────────────────────────────────────
const getTodayIST = () => {
  const now = new Date();
  const ist = new Date(
    now.toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
    })
  );
  const yyyy = ist.getFullYear();
  const mm = String(ist.getMonth() + 1).padStart(2, "0");
  const dd = String(ist.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const parseDate = (dateStr) => {
  if (!dateStr) return new Date();
  const [yyyy, mm, dd] = dateStr.split("-").map(Number);
  return new Date(yyyy, mm - 1, dd);
};

const DAY_ABBR = [ "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const DAY_FULL = [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday","Sunday"];

// ─── Notice Display Component ────────────────────────────────────────
const NoticeDisplay = ({ noticeData }) => {
  if (!noticeData) return null;

  const totalDays = calculateTotalNoticeDays(noticeData.NoticeDate, noticeData.VacateDate);
  const remainingDays = calculateRemainingDays(noticeData.VacateDate);
  
  const isShortNotice = totalDays !== null && totalDays < 30;
  const noticeType = isShortNotice ? 'Short Notice' : 'Standard Notice';
  const noticeColor = isShortNotice ? '#DC2626' : '#D97706';
  const noticeBg = isShortNotice ? '#FEF2F2' : '#FFFBEB';
  const noticeBorder = isShortNotice ? '#FECACA' : '#FDE68A';

  return (
    <div className="td-notice-display" style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '4px 12px',
      borderRadius: '12px',
      fontSize: '13px',
      fontWeight: '500',
      background: noticeBg,
      border: `1px solid ${noticeBorder}`,
      color: noticeColor
    }}>
      <span>{noticeType}</span>
      {totalDays !== null && (
        <span style={{ opacity: 0.7 }}>•</span>
      )}
      {totalDays !== null && (
        <span>({totalDays} days)</span>
      )}
      {remainingDays !== null && (
        <>
          <span style={{ opacity: 0.7 }}>•</span>
          <span style={{ 
            color: remainingDays < 30 ? '#DC2626' : '#D97706',
            fontWeight: '600'
          }}>
            {remainingDays < 0 
              ? `Overdue by ${Math.abs(remainingDays)}d ⚠️`
              : `${remainingDays}d remaining`
            }
          </span>
        </>
      )}
    </div>
  );
};

// ─── TENANT DASHBOARD ─────────────────────────────────────────────
const TenantDashboard = () => {
  const navigate = useNavigate()
  const { logout, user, userDataList, updateTenantProfile } = useAuth()

  const tenantPGs = userDataList || []
  console.log("userDataList", userDataList)
  
  const [selectedPGIndex, setSelectedPGIndex] = useState(0)

  const currentPG = tenantPGs[selectedPGIndex] || {}
  console.log("currentPG", currentPG);

  const tenantId = currentPG.TenantID
  const pgId = currentPG.PGID
  const tenantName = currentPG.TenantName || 'Tenant'
  const tenantInitials = tenantName.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)

  // ─── New State for Notice ───────────────────────────────────────
  const [noticeData, setNoticeData] = useState(null);
  const [noticeLoading, setNoticeLoading] = useState(false);

  const roomDisplay = currentPG.RoomNumber && currentPG.BedNumber 
    ? `Room ${currentPG.RoomNumber} (Bed ${currentPG.BedNumber}) - ${currentPG.Floor || ''}`
    : currentPG.RoomNumber 
      ? `Room ${currentPG.RoomNumber}` 
      : '—'

  const pgDisplay = currentPG.PGName && currentPG.PGCode
    ? `${currentPG.PGName} (${currentPG.PGCode})`
    : currentPG.PGName || `PG #${pgId || '—'}`

  const rentAmount = currentPG.NetPayable  || 0

  const [notifOpen, setNotifOpen] = useState(false)
  const [profileOpen, setProfileOpen] = useState(false)
  const [modal, setModal] = useState(null)
  const [activities, setActivities] = useState([])
  const [loading, setLoading] = useState(true)
  const [openMonths, setOpenMonths] = useState({})
  const [showLogoutModal, setShowLogoutModal] = useState(false)
  const [showNoPGWarning, setShowNoPGWarning] = useState(false)
  const [showComingSoon, setShowComingSoon] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [foodMenuOpen, setFoodMenuOpen] = useState(false);

  // ─── Fetch Notice Data ─────────────────────────────────────────
  useEffect(() => {
    if (currentPG.AdmissionId) {
      fetchNoticeData();
    }
  }, [currentPG.AdmissionId, selectedPGIndex]);

  const fetchNoticeData = async () => {
    if (!currentPG.AdmissionId) return;
    
    setNoticeLoading(true);
    try {
      const response = await getTenantNoticeByAdmission(currentPG.AdmissionId);
      console.log('Notice API Response:', response);
      
      if (response && response.success && response.data && response.data.length > 0) {
        setNoticeData(response.data[0]);
      } else {
        setNoticeData(null);
      }
    } catch (error) {
      console.error('Error fetching notice data:', error);
      setNoticeData(null);
    } finally {
      setNoticeLoading(false);
    }
  };

  useEffect(() => {
    if (tenantId && pgId && !hasNoPG) {
      fetchActivities()
    } else {
      setLoading(false)
    }
  }, [tenantId, pgId, selectedPGIndex])

  const fetchActivities = async () => {
    setLoading(true)
    try {
      const complaints = await getComplaintsByTenantId(tenantId)
      const complaintActivities = (complaints || []).map(c => ({
        type: 'complaint',
        title: c.ComplaintText,
        sub: c.ComplaintText?.split(':')[0] || 'Complaint',
        status: c.ComplaintStatus,
        date: c.ComplaintDate
      }))

      const compliance = await GetComplianceByTenant(tenantId)
      const tenantCompliance = (compliance || []).filter(c => c.TenantID === tenantId)
      const complianceActivities = tenantCompliance.map(c => {
        let type = 'visitor'
        if (c.ComplianceType?.toLowerCase().includes('check') || c.ComplianceType?.toLowerCase().includes('in/out')) {
          type = 'checkinout'
        }
        return {
          type: type,
          title: c.Title || c.ComplianceType,
          sub: c.ComplianceDetails || c.DateRange || '',
          status: c.Status,
          date: c.CreatedDate
        }
      })

      const allActivities = [...complaintActivities, ...complianceActivities]
        .sort((a, b) => new Date(b.date) - new Date(a.date))

      setActivities(allActivities)
    } catch (error) {
      console.error('Error fetching activities:', error)
      setErrorMessage('Failed to load activities. Please refresh the page.')
      setShowErrorModal(true)
    } finally {
      setLoading(false)
    }
  }

  const hasNoPG = !tenantId || !pgId || tenantPGs.length === 0
  useEffect(() => {
    if (hasNoPG) {
      setShowNoPGWarning(true)
    }
  }, [hasNoPG])

  const handleActivitySubmit = (data) => {
    const newActivity = {
      ...data,
      id: Date.now()
    }
    setActivities(prev => [newActivity, ...prev])
    const month = getMonthYear(data.date)
    setOpenMonths(prev => ({ ...prev, [month]: true }))
    fetchActivities()
    
    let successMsg = ''
    if (data.type === 'complaint') successMsg = 'Your complaint has been submitted successfully. The admin will review it shortly.'
    else if (data.type === 'visitor') successMsg = 'Visitor request has been submitted successfully.'
    else if (data.type === 'checkinout') successMsg = 'Check In/Out request has been submitted successfully.'
    else if (data.type === 'noticeperiod') successMsg = 'Your notice period request has been submitted successfully.'
    
    setSuccessMessage(successMsg)
    setShowSuccessModal(true)
  }

  const handleProfileUpdate = (updatedData) => {
    updateTenantProfile(updatedData)
    fetchActivities()
  }

  const handleLogoutClick = () => {
    setShowLogoutModal(true)
  }

  const handleConfirmLogout = () => {
    logout()
    navigate('/')
  }

  const handleCancelLogout = () => {
    setShowLogoutModal(false)
  }

  const handleAgreementClick = () => {
    setModal('agreement')
  }

  const handleComingSoon = () => {
    setShowComingSoon(true)
  }

  const ACTIVE_STATUSES = ['PENDING', 'OPEN', 'IN_PROGRESS']
  const activeItems = activities.filter(a => ACTIVE_STATUSES.includes(a.status?.toUpperCase()))
  const historyItems = activities.filter(a => !ACTIVE_STATUSES.includes(a.status?.toUpperCase()))

  const byMonth = {}
  historyItems.forEach(a => {
    const month = getMonthYear(a.date)
    if (!byMonth[month]) byMonth[month] = []
    byMonth[month].push(a)
  })
  const sortedMonths = Object.keys(byMonth).sort((a, b) => new Date(b) - new Date(a))

  const activeComplaintCount = activeItems.filter(a => a.type === 'complaint').length

  if (loading) {
    return (
      <div className="td-root">
        <header className="td-navbar">
          <div className="td-navbar-inner">
            <button className="td-brand" onClick={() => navigate('/')}>
              <img src="/assets/AapkaPG-logo.svg" alt="KYS PG" className="od-navbar-logo" />
            </button>
            <div className="td-navbar-right">
              <div className="td-notif-wrap">
                <button className="td-bell-btn" onClick={() => setNotifOpen(p => !p)}>
                  {Icon.bell}
                </button>
              </div>
              <button className="td-avatar-btn" onClick={() => setProfileOpen(true)}>
                {tenantInitials}
              </button>
              <button className="td-logout-btn" onClick={handleLogoutClick}>
                {Icon.logout}
              </button>
            </div>
          </div>
        </header>

        <div className="td-hero">
          <div className="td-hero-inner">
            <div>
              <div className="td-hero-welcome-skeleton"></div>
              <div className="td-hero-name-skeleton"></div>
              <div className="td-hero-sub-skeleton"></div>
            </div>
            <div className="td-hero-avatar-skeleton"></div>
          </div>
        </div>

        <main className="td-main">
          <div className="td-container">
            <div className="td-stats-grid">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="td-stat-card-skeleton">
                  <div className="td-stat-top-skeleton">
                    <div className="td-stat-icon-skeleton"></div>
                    <div className="td-stat-label-skeleton"></div>
                  </div>
                  <div className="td-stat-value-skeleton"></div>
                </div>
              ))}
            </div>

            <div className="td-section">
              <div className="td-section-title-skeleton"></div>
              <div className="td-actions-grid">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="td-action-card-skeleton">
                    <div className="td-action-icon-skeleton"></div>
                    <div className="td-action-label-skeleton"></div>
                  </div>
                ))}
              </div>
            </div>

            <div className="td-section">
              <div className="td-section-title-skeleton"></div>
              <div className="td-activity-list-skeleton">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="td-activity-item-skeleton">
                    <div className="td-activity-icon-skeleton"></div>
                    <div className="td-activity-content-skeleton">
                      <div className="td-activity-title-skeleton"></div>
                      <div className="td-activity-meta-skeleton"></div>
                    </div>
                    <div className="td-activity-status-skeleton"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>

        <style>{`
          @keyframes td-shimmer {
            0% { background-position: -200px 0; }
            100% { background-position: calc(200px + 100%) 0; }
          }
          .td-shimmer {
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200px 100%;
            animation: td-shimmer 1.5s infinite;
            border-radius: 8px;
          }
          .td-brand-skeleton { width: 120px; height: 40px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 8px; }
          .td-bell-skeleton { width: 40px; height: 40px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 50%; }
          .td-avatar-skeleton { width: 40px; height: 40px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 50%; }
          .td-logout-skeleton { width: 40px; height: 40px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 8px; }
          .td-hero-welcome-skeleton { width: 120px; height: 18px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 4px; margin-bottom: 8px; }
          .td-hero-name-skeleton { width: 180px; height: 32px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 4px; margin-bottom: 8px; }
          .td-hero-sub-skeleton { width: 150px; height: 16px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 4px; }
          .td-hero-avatar-skeleton { width: 64px; height: 64px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 50%; }
          .td-stat-card-skeleton { background: white; border-radius: 12px; padding: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.06); border: 1px solid #f3f4f6; }
          .td-stat-top-skeleton { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
          .td-stat-icon-skeleton { width: 32px; height: 32px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 8px; }
          .td-stat-label-skeleton { width: 80px; height: 14px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 4px; }
          .td-stat-value-skeleton { width: 100px; height: 28px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 4px; }
          .td-section-title-skeleton { width: 160px; height: 24px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 4px; margin-bottom: 16px; }
          .td-action-card-skeleton { background: white; border-radius: 12px; padding: 20px; display: flex; flex-direction: column; align-items: center; gap: 10px; border: 1px solid #f3f4f6; min-height: 80px; justify-content: center; }
          .td-action-icon-skeleton { width: 40px; height: 40px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 50%; }
          .td-action-label-skeleton { width: 80px; height: 14px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 4px; }
          .td-activity-list-skeleton { background: white; border-radius: 12px; padding: 16px; border: 1px solid #f3f4f6; }
          .td-activity-item-skeleton { display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f3f4f6; }
          .td-activity-item-skeleton:last-child { border-bottom: none; }
          .td-activity-icon-skeleton { width: 36px; height: 36px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 50%; flex-shrink: 0; }
          .td-activity-content-skeleton { flex: 1; display: flex; flex-direction: column; gap: 6px; }
          .td-activity-title-skeleton { width: 60%; height: 16px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 4px; }
          .td-activity-meta-skeleton { width: 40%; height: 12px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 4px; }
          .td-activity-status-skeleton { width: 70px; height: 24px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200px 100%; animation: td-shimmer 1.5s infinite; border-radius: 12px; flex-shrink: 0; }
          .td-loading { display: block; min-height: 100vh; background: #F9FAFB; }
          .td-spinner { display: none; }
        `}</style>
      </div>
    )
  }

  return (
    <div className="td-root">
      {profileOpen && (
        <ProfileDrawer 
          onClose={() => setProfileOpen(false)} 
          onProfileUpdate={handleProfileUpdate}
          tenantData={currentPG}
        />
      )}
        
      {modal === 'complaint' && (
        <ComplaintModal
          onClose={() => setModal(null)}
          onSubmit={handleActivitySubmit}
          tenantId={tenantId}
          pgId={pgId}
          currentPG={currentPG}
        />
      )}
      {modal === 'checkinout' && (
        <CheckInOutModal
          onClose={() => setModal(null)}
          onSubmit={handleActivitySubmit}
          tenantId={tenantId}
          pgId={pgId}
          currentPG={currentPG}
        />
      )}
      {modal === 'visitor' && (
        <VisitorModal
          onClose={() => setModal(null)}
          onSubmit={handleActivitySubmit}
          tenantId={tenantId}
          pgId={pgId}
          currentPG={currentPG}
        />
      )}
      {modal === 'agreement' && (
        <AgreementModal 
          onClose={() => setModal(null)} 
          onComingSoon={handleComingSoon}
          currentPG={currentPG}
        />
      )}
      {modal === 'noticeperiod' && (
        <NoticePeriodModal
          onClose={() => setModal(null)}
          onSubmit={handleActivitySubmit}
          tenantId={tenantId}
          pgId={pgId}
          currentPG={currentPG}
        />
      )}

      {showLogoutModal && (
        <LogoutConfirmationModal 
          onClose={handleCancelLogout} 
          onConfirm={handleConfirmLogout} 
        />
      )}

      {showNoPGWarning && userDataList.length === 0 && (
        <NoPGLinkedModal onClose={() => {
          handleConfirmLogout()
          setShowNoPGWarning(false)
        }} />
      )}

      <SuccessModal 
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Success!"
        message={successMessage}
      />

      <ErrorModal 
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        title="Error"
        message={errorMessage}
      />

      <ComingSoonModal 
        isOpen={showComingSoon}
        onClose={() => setShowComingSoon(false)}
      />

      {foodMenuOpen && (
        <FoodMenuModal
          isOpen={foodMenuOpen}
          onClose={() => setFoodMenuOpen(false)}
          selectedPG={currentPG}
        />
      )}

      {!hasNoPG ? (
        <>
          <header className="td-navbar">
            <div className="td-navbar-inner">
              <button className="td-brand" onClick={() => navigate('/')}>
                <img src="/assets/AapkaPG-logo.svg" alt="KYS PG" className="od-navbar-logo" />
              </button>

              <div className="td-navbar-right">
                <div className="td-notif-wrap">
                  <button className="td-bell-btn" onClick={() => setNotifOpen(p => !p)}>
                    {Icon.bell}
                  </button>
                </div>

                <button className="td-avatar-btn" onClick={() => setProfileOpen(true)}>
                  {tenantInitials}
                </button>

                <button className="td-logout-btn" onClick={handleLogoutClick}>
                  {Icon.logout}
                </button>
              </div>
            </div>
          </header>

          <div className="td-hero">
            <div className="td-hero-inner">
              <div>
                <p className="td-hero-welcome">Welcome back,</p>
                <h1 className="td-hero-name">{tenantName}</h1>
                <p className="td-hero-sub">{roomDisplay}</p>
                {/* ─── Notice Display ─────────────────────────── */}
                {!noticeLoading && noticeData && (
                  <div style={{ marginTop: '8px' }}>
                    <NoticeDisplay noticeData={noticeData} />
                  </div>
                )}
              </div>
              <div className="td-hero-right">
                {tenantPGs.length > 0 && (
                  <div className="td-pg-dropdown-wrap">
                    <select 
                      className="td-pg-dropdown"
                      value={selectedPGIndex}
                      onChange={(e) => setSelectedPGIndex(parseInt(e.target.value))}
                    >
                      {tenantPGs.map((pg, index) => (
                        <option key={index} value={index}>
                          {pg.PGName || `PG #${pg.PGID}`} ({pg.PGCode || '—'})
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div className="td-hero-avatar">{tenantInitials}</div>
              </div>
            </div>
          </div>

          <main className="td-main">
            <div className="td-container">
              <div className="td-stats-grid">
                <StatCard icon={Icon.rupee} label="Rent Due" value={`₹${rentAmount.toLocaleString() || '0'}`} valueClass="td-stat-amber" />
                <StatCard icon={Icon.calendar} label="Due Date" value={currentPG.DueDate ? formatDate(currentPG.DueDate) : '—'} />
                <StatCard icon={Icon.chat} label="Active Complaints" value={String(activeComplaintCount)} valueClass="td-stat-amber" />
                <StatCard icon={Icon.bell} label="Total Activities" value={String(activities.length)} valueClass="td-stat-indigo" />
              </div>

              <div className="td-section">
                <h2 className="td-section-title">Quick Actions</h2>
                <div className="td-actions-grid">
                  <ActionCard icon={Icon.complaint} label="Raise Complaint" color="#EF4444" bg="#FFF1F2" onClick={() => setModal('complaint')} />
                  <ActionCard icon={Icon.calendar} label="Schedule Check In/Out" color="#EF4444" bg="#FFF1F2" onClick={() => setModal('checkinout')} />
                  <ActionCard icon={Icon.visitor} label="Add Visitor" color="#EF4444" bg="#FFF1F2" onClick={() => setModal('visitor')} />
                  <ActionCard icon={Icon.doc} label="View Agreement" color="#EF4444" bg="#FFF1F2" onClick={handleAgreementClick} />                
                  <ActionCard
                    icon={
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                        <path d="M7 2v5H6V2H5v5H4V2H3v5c0 1.93 1.28 3.55 3 4.07V22h1v-10.93c1.72-.52 3-2.14 3-4.07V2H9v5H8V2H7z" />
                        <path d="M17 2c-1.38 0-2.5 1.12-2.5 2.5v7.5c0 .55.45 1 1 1h1.5V22h1V2s-1-.03-1 0z" />
                      </svg>
                    }
                    label="Food Menu"
                    color="#EF4444"
                    bg="#FFF1F2"
                    onClick={() => setFoodMenuOpen(true)}
                  />
                  <ActionCard icon={Icon.calendar} label="Notice Period" color="#EF4444" bg="#FFF1F2" onClick={() => setModal('noticeperiod')} />
                </div>
              </div>

              <div className="td-section">
                <h2 className="td-section-title">Recent Activity</h2>

                {activeItems.length > 0 && (
                  <div className="td-active-strip">
                    <div className="td-active-strip-head">
                      <span className="td-active-strip-label">Active</span>
                      <span className="td-active-badge">{activeItems.length}</span>
                    </div>
                    {activeItems.map((a, idx) => (
                      <div key={idx} className="td-act-row">
                        <ActivityIcon type={a.type} />
                        <div className="td-act-info">
                          <span className="td-act-title">{a.title}</span>
                          <span className="td-act-meta">
                            <span className="td-act-type-pill" style={{ color: TYPE_CFG[a.type]?.color, background: TYPE_CFG[a.type]?.bg }}>
                              {TYPE_CFG[a.type]?.label}
                            </span>
                            · {a.sub} · {formatDate(a.date)}
                          </span>
                        </div>
                        <StatusBadge status={a.status} />
                      </div>
                    ))}
                  </div>
                )}

                {sortedMonths.length > 0 && (
                  <div className="td-acc-list">
                    {sortedMonths.map(month => (
                      <ActivityAccordion
                        key={month}
                        month={month}
                        items={byMonth[month]}
                        defaultOpen={false}
                      />
                    ))}
                  </div>
                )}

                {activities.length === 0 && (
                  <div className="td-empty-state">
                    <p>No activities yet. Use quick actions to get started!</p>
                  </div>
                )}
              </div>
            </div>
          </main>
        </>
      ) : null}

      <style>{`
        .td-loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          background: #F9FAFB;
        }
        .td-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #E5E7EB;
          border-top-color: #6366F1;
          border-radius: 50%;
          animation: td-spin 0.8s linear infinite;
          margin-bottom: 16px;
        }
        @keyframes td-spin {
          to { transform: rotate(360deg); }
        }
        .td-empty-state {
          text-align: center;
          padding: 48px 20px;
          background: #F9FAFB;
          border-radius: 12px;
          color: #6B7280;
        }
        .td-no-pg-icon-wrapper {
          width: 64px;
          height: 64px;
          background: #FEF3C7;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          color: #D97706;
        }
        .td-logout-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          animation: td-fadeIn 0.2s ease-out;
        }
        @keyframes td-fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .td-logout-modal {
          background: white;
          border-radius: 20px;
          width: 90%;
          max-width: 400px;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
          animation: td-slideUp 0.3s ease-out;
        }
        @keyframes td-slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .td-logout-modal-header { padding: 24px 24px 0 24px; text-align: center; }
        .td-logout-icon-wrapper {
          width: 64px; height: 64px; background: #FEF2F2; border-radius: 50%;
          display: flex; align-items: center; justify-content: center; margin: 0 auto; color: #DC2626;
        }
        .td-logout-modal-body { padding: 20px 24px; text-align: center; }
        .td-logout-modal-title { font-size: 20px; font-weight: 600; color: #1F2937; margin-bottom: 8px; }
        .td-logout-modal-message { font-size: 14px; color: #6B7280; line-height: 1.5; }
        .td-logout-modal-footer { padding: 16px 24px 24px 24px; display: flex; gap: 12px; }
        .td-logout-btn-cancel, .td-logout-btn-confirm {
          flex: 1; padding: 10px 16px; border-radius: 10px; font-size: 14px;
          font-weight: 500; cursor: pointer; transition: all 0.2s; border: none;
        }
        .td-logout-btn-cancel { background: #F3F4F6; color: #4B5563; }
        .td-logout-btn-cancel:hover { background: #E5E7EB; }
        .td-logout-btn-confirm { background: #DC2626; color: white; }
        .td-logout-btn-confirm:hover { background: #B91C1C; }
        
        .td-input-err { border-color: #EF4444 !important; background-color: #FEF2F2 !important; }
        .td-hint { font-size: 11px; color: #9CA3AF; margin-top: 2px; }

        .td-hero-right {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .td-pg-dropdown-wrap {
          display: flex;
          align-items: center;
        }

        .td-pg-dropdown {
          padding: 8px 12px;
          border-radius: 8px;
          border: 1px solid #E5E7EB;
          background: white;
          font-size: 14px;
          font-weight: 500;
          color: #1F2937;
          cursor: pointer;
          outline: none;
          transition: all 0.2s;
          min-width: 180px;
        }

        .td-pg-dropdown:hover {
          border-color: #F06E18;
        }

        .td-pg-dropdown:focus {
          border-color: #F06E18;
          box-shadow: 0 0 0 3px rgba(240, 110, 24, 0.1);
        }

        .td-notice-display {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 13px;
          font-weight: 500;
        }
      `}</style>
    </div>
  )
}

export default TenantDashboard

// import React, { useState, useRef, useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { useAuth } from '../context/authcontext'
// import { insertComplaint, insertCompliance, getComplaintsByTenantId, GetComplianceByTenant, getWeeklyFoodMenu, tenantNoticeInsert } from '../apis/services/pgApi'
// import ProfileDrawer from './profiledrawer'

// // ─── Constants ────────────────────────────────────────────────────
// const COMPLAINT_CATS = [
//   'Water Leakage', 'WiFi Issue', 'AC Not Working', 'Noisy Neighbours', 'Housekeeping',
//   'Door Lock', 'Plumbing', 'Electricity', 'Security', 'Pest Control', 'Furniture',
//   'Geyser/Hot Water', 'Laundry', 'Food Quality', 'Cleanliness', 'Fan', 'Drainage', 'Other',
// ]

// // ─── SVG Icons ───────────────────────────────────────────────────
// const Icon = {
//   rupee: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="1.5" strokeLinecap="round"><path d="M12.9494914,6 C13.4853936,6.52514205 13.8531598,7.2212202 13.9645556,8 L17.5,8 C17.7761424,8 18,8.22385763 18,8.5 C18,8.77614237 17.7761424,9 17.5,9 L13.9645556,9 C13.7219407,10.6961471 12.263236,12 10.5,12 L7.70710678,12 L13.8535534,18.1464466 C14.0488155,18.3417088 14.0488155,18.6582912 13.8535534,18.8535534 C13.6582912,19.0488155 13.3417088,19.0488155 13.1464466,18.8535534 L6.14644661,11.8535534 C5.83146418,11.538571 6.05454757,11 6.5,11 L10.5,11 C11.709479,11 12.7183558,10.1411202 12.9499909,9 L6.5,9 C6.22385763,9 6,8.77614237 6,8.5 C6,8.22385763 6.22385763,8 6.5,8 L12.9499909,8 C12.7183558,6.85887984 11.709479,6 10.5,6 L6.5,6 C6.22385763,6 6,5.77614237 6,5.5 C6,5.22385763 6.22385763,5 6.5,5 L10.5,5 L17.5,5 C17.7761424,5 18,5.22385763 18,5.5 C18,5.77614237 17.7761424,6 17.5,6 L12.9494914,6 L12.9494914,6 Z" /></svg>,
//   bell: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" /></svg>,
//   logout: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" /></svg>,
//   calendar: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>,
//   chat: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /></svg>,
//   alert: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>,
//   visitor: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" /></svg>,
//   complaint: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>,
//   doc: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>,
//   chevDown: <svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M3 5L7 9L11 5" stroke="#F06E18" strokeWidth="1.6" strokeLinecap="round" /></svg>,
//   close: <svg width="14" height="14" viewBox="0 0 18 18" fill="none"><path d="M1 1L17 17M17 1L1 17" stroke="#F06E18" strokeWidth="2" strokeLinecap="round" /></svg>,
//   edit: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>,
//   check: <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6L5 9L10 3" stroke="#F06E18" strokeWidth="2" strokeLinecap="round" /></svg>,
//   phone: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.5 19.79 19.79 0 01.4.84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg>,
//   mail: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>,
//   shield: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>,
//   building: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg>,
//   bed: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M2 4v16M2 8h18a2 2 0 012 2v8M2 16h20" /></svg>,
//   pin: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>,
//   fork: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="2" x2="12" y2="22" /><path d="M17 5H9.5a3.5 3.5 0 000 7h5" /></svg>,
//   person: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
//   company: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="2" strokeLinecap="round"><rect x="2" y="7" width="20" height="14" rx="1" /><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" /></svg>,
//   download: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" /></svg>,
// }

// // ─── Helper Functions ────────────────────────────────────────────────
// const formatDate = (dateString) => {
//   if (!dateString) return '—'
//   const date = new Date(dateString)
//   return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
// }

// const getMonthYear = (dateString) => {
//   if (!dateString) return 'Unknown'
//   const date = new Date(dateString)
//   return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
// }

// const getTodayDateOnly = () => {
//   const d = new Date()
//   d.setHours(0, 0, 0, 0)
//   return d
// }

// const addDays = (date, days) => {
//   const d = new Date(date)
//   d.setDate(d.getDate() + days)
//   return d
// }

// const toDateInputValue = (date) => date.toISOString().split('T')[0]

// // ─── Modal wrapper ────────────────────────────────────────────────
// const Modal = ({ title, onClose, children, footer }) => (
//   <div className="td-modal-overlay" >
//     <div className="td-modal" onClick={e => e.stopPropagation()}>
//       <div className="td-modal-head">
//         <h3 className="td-modal-title">{title}</h3>
//         <button className="td-modal-close" onClick={onClose}>{Icon.close}</button>
//       </div>
//       <div className="td-modal-body">{children}</div>
//       {footer && <div className="td-modal-footer">{footer}</div>}
//     </div>
//   </div>
// )

// // ─── Success Modal ────────────────────────────────────────────────────
// const SuccessModal = ({ isOpen, onClose, title, message }) => {
//   if (!isOpen) return null
  
//   return (
//     <div className="td-success-overlay">
//       <div className="td-success-modal" onClick={e => e.stopPropagation()}>
//         <div className="td-success-icon-wrapper">
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2">
//             <circle cx="12" cy="12" r="10" />
//             <path d="M8 12L11 15L16 9" />
//           </svg>
//         </div>
//         <h3 className="td-success-title">{title}</h3>
//         <p className="td-success-message">{message}</p>
//         <div className="td-success-footer">
//           <button className="td-success-btn" onClick={onClose}>Got it</button>
//         </div>
//       </div>
//     </div>
//   )
// }

// // ─── Error Modal ────────────────────────────────────────────────────
// const ErrorModal = ({ isOpen, onClose, title, message }) => {
//   if (!isOpen) return null
  
//   return (
//     <div className="td-error-overlay">
//       <div className="td-error-modal" onClick={e => e.stopPropagation()}>
//         <div className="td-error-icon-wrapper">
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2">
//             <circle cx="12" cy="12" r="10" />
//             <line x1="12" y1="8" x2="12" y2="12" />
//             <line x1="12" y1="16" x2="12.01" y2="16" />
//           </svg>
//         </div>
//         <h3 className="td-error-title">{title}</h3>
//         <p className="td-error-message">{message}</p>
//         <div className="td-error-footer">
//           <button className="td-error-btn" onClick={onClose}>OK</button>
//         </div>
//       </div>
//     </div>
//   )
// }

// // ─── Coming Soon Modal ───────────────────────────────────────────────
// const ComingSoonModal = ({ isOpen, onClose }) => {
//   if (!isOpen) return null
  
//   return (
//     <div className="td-comingsoon-overlay">
//       <div className="td-comingsoon-modal" onClick={e => e.stopPropagation()}>
//         <div className="td-comingsoon-icon-wrapper">
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2">
//             <path d="M12 8v4l3 3M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
//           </svg>
//         </div>
//         <h3 className="td-comingsoon-title">Coming Soon!</h3>
//         <p className="td-comingsoon-message">This feature is currently under development and will be available soon. Stay tuned!</p>
//         <div className="td-comingsoon-footer">
//           <button className="td-comingsoon-btn" onClick={onClose}>Got it</button>
//         </div>
//       </div>
//     </div>
//   )
// }

// // ─── Logout Confirmation Modal ────────────────────────────────────
// const LogoutConfirmationModal = ({ onClose, onConfirm }) => {
//   return (
//     <div className="td-logout-overlay" >
//       <div className="td-logout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="td-logout-modal-header">
//           <div className="td-logout-icon-wrapper">
//             <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
//               <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
//             </svg>
//           </div>
//         </div>
//         <div className="td-logout-modal-body">
//           <h3 className="td-logout-modal-title">Confirm Logout</h3>
//           <p className="td-logout-modal-message">Are you sure you want to log out? You will need to log in again to access your account.</p>
//         </div>
//         <div className="td-logout-modal-footer">
//           <button className="td-logout-btn-cancel" onClick={onClose}>Cancel</button>
//           <button className="td-logout-btn-confirm" onClick={onConfirm}>Logout</button>
//         </div>
//       </div>
//     </div>
//   )
// }

// // ─── No PG Linked Warning Modal ────────────────────────────────────────────
// const NoPGLinkedModal = ({ onClose }) => {
//   return (
//     <div className="td-logout-overlay" >
//       <div className="td-logout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="td-logout-modal-header">
//           <div className="td-no-pg-icon-wrapper">
//             <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
//               <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//           </div>
//         </div>
//         <div className="td-logout-modal-body">
//           <h3 className="td-logout-modal-title">No PG Linked</h3>
//           <p className="td-logout-modal-message">You are not linked to any PG yet. Please contact your PG owner to get registered. Once linked, your dashboard will show all the details.</p>
//         </div>
//         <div className="td-logout-modal-footer">
//           <button className="td-logout-btn-confirm" onClick={onClose}>Got it</button>
//         </div>
//       </div>
//     </div>
//   )
// }

// // ─── Security Deposit Deduction Confirmation Modal ────────────────
// const SecurityDeductionConfirmModal = ({ onClose, onConfirm, vacateDate, isSubmitting = false }) => {
//   return (
//     <div className="td-logout-overlay">
//       <div className="td-logout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="td-logout-modal-header">
//           <div className="td-warn-icon-wrapper">
//             <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
//               <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" fill="currentColor" />
//               <rect x="11" y="8.25" width="2" height="6" rx="1" fill="#FFFBEB" />
//               <circle cx="12" cy="17" r="1.15" fill="#FFFBEB" />
//             </svg>
//           </div>
//         </div>
//         <div className="td-logout-modal-body">
//           <h3 className="td-logout-modal-title">Security Deposit Deduction</h3>
//           <p className="td-logout-modal-message">
//             Vacating on {vacateDate} is earlier than your standard notice period. As per your PG's short-notice policy, an applicable amount will be deducted from your security deposit. Do you want to proceed?
//           </p>
//         </div>
//         <div className="td-logout-modal-footer">
//           <button 
//             className="td-logout-btn-cancel" 
//             onClick={onClose}
//             disabled={isSubmitting}
//           >
//             Cancel
//           </button>
//           <button 
//             className="td-logout-btn-confirm td-warn-confirm-btn" 
//             onClick={onConfirm}
//             disabled={isSubmitting}
//           >
//             {isSubmitting ? 'Processing...' : 'Yes, I Understand'}
//           </button>
//         </div>
//       </div>
//     </div>
//   )
// }

// // const SecurityDeductionConfirmModal = ({ onClose, onConfirm, vacateDate }) => {
// //   return (
// //     <div className="td-logout-overlay">
// //       <div className="td-logout-modal" onClick={(e) => e.stopPropagation()}>
// //         <div className="td-logout-modal-header">
// //           <div className="td-warn-icon-wrapper">
// //             <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
// //               <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" fill="currentColor" />
// //               <rect x="11" y="8.25" width="2" height="6" rx="1" fill="#FFFBEB" />
// //               <circle cx="12" cy="17" r="1.15" fill="#FFFBEB" />
// //             </svg>
// //           </div>
// //         </div>
// //         <div className="td-logout-modal-body">
// //           <h3 className="td-logout-modal-title">Security Deposit Deduction</h3>
// //           <p className="td-logout-modal-message">
// //             Vacating on {vacateDate} is earlier than your standard notice period. As per your PG's short-notice policy, an applicable amount will be deducted from your security deposit. Do you want to proceed?
// //           </p>
// //         </div>
// //         <div className="td-logout-modal-footer">
// //           <button className="td-logout-btn-cancel" onClick={onClose}>Cancel</button>
// //           <button className="td-logout-btn-confirm td-warn-confirm-btn" onClick={onConfirm}>
// //             Yes, I Understand
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   )
// // }

// // ─── Complaint Modal with Validations ──────────────────────────────────────────────

// const ComplaintModal = ({ onClose, onSubmit, tenantId, pgId, currentPG }) => {
//   const [cat, setCat] = useState('')
//   const [desc, setDesc] = useState('')
//   const [loading, setLoading] = useState(false)
//   const [errors, setErrors] = useState({})
//   const [showErrorModal, setShowErrorModal] = useState(false)
//   const [errorMessage, setErrorMessage] = useState('')

//   const validateCategory = (value) => {
//     if (!value) return 'Please select a category'
//     return ''
//   }

//   const validateDescription = (value) => {
//     if (!value || !value.trim()) return 'Description is required'
//     if (value.length < 10) return 'Please provide more detail (minimum 10 characters)'
//     if (value.length > 500) return 'Description must be less than 500 characters'
//     return ''
//   }

//   const handleCategoryChange = (value) => {
//     setCat(value)
//     const error = validateCategory(value)
//     setErrors(prev => ({ ...prev, cat: error }))
//   }

//   const handleDescChange = (value) => {
//     setDesc(value)
//     const error = validateDescription(value)
//     setErrors(prev => ({ ...prev, desc: error }))
//   }

//   const validateForm = () => {
//     const newErrors = {}
//     const catError = validateCategory(cat)
//     if (catError) newErrors.cat = catError
//     const descError = validateDescription(desc)
//     if (descError) newErrors.desc = descError
//     setErrors(newErrors)
//     return Object.keys(newErrors).length === 0
//   }

//   const submit = async () => {
//     if (!validateForm()) return

//     setLoading(true)
//     try {
//       const result = await insertComplaint({
//         PGID: pgId,
//         TenantID: tenantId,
//         ComplaintText: `${cat}: ${desc.substring(0, 100)}`,
//         ComplaintDate: new Date().toISOString(),
//       })

//       if (result && result.ComplaintID) {
//         onSubmit({
//           type: 'complaint',
//           title: `${cat}: ${desc.substring(0, 50)}`,
//           sub: cat,
//           status: 'OPEN',
//           date: new Date().toISOString()
//         })
//         onClose()
//       } else {
//         setErrorMessage(result?.Message || 'Failed to submit complaint. Please try again.')
//         setShowErrorModal(true)
//       }
//     } catch (error) {
//       console.error('Error submitting complaint:', error)
//       setErrorMessage(error.message || 'Failed to submit complaint. Please try again.')
//       setShowErrorModal(true)
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <>
//       <Modal title="New Complaint" onClose={onClose}
//         footer={<>
//           <button className="td-btn td-btn-outline" onClick={onClose}>Cancel</button>
//           <button className="td-btn td-btn-primary" onClick={submit} disabled={loading}>
//             {loading ? 'Submitting...' : 'Submit'}
//           </button>
//         </>}>
//         <div className="td-form-grid">
//           <div className="td-field td-field-half">
//             <label className="td-label">Category <span className="td-req">*</span></label>
//             <select 
//               className={`td-select ${errors.cat ? 'td-input-err' : ''}`} 
//               value={cat} 
//               onChange={e => handleCategoryChange(e.target.value)}
//             >
//               <option value="">Select category</option>
//               {COMPLAINT_CATS.map(c => <option key={c} value={c}>{c}</option>)}
//             </select>
//             {errors.cat && <span className="td-err">{errors.cat}</span>}
//           </div>
//           <div className="td-field td-field-full">
//             <label className="td-label">Description <span className="td-req">*</span></label>
//             <textarea 
//               className={`td-textarea ${errors.desc ? 'td-input-err' : ''}`} 
//               rows={3}
//               placeholder="Describe your issue in detail (minimum 10 characters)..."
//               value={desc}
//               maxLength={500}
//               onChange={e => handleDescChange(e.target.value)} 
//             />
//             <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#9CA3AF', marginTop: '4px' }}>
//               <span>{desc.length}/500 characters</span>
//               {desc && desc.length < 10 && desc.length > 0 && (
//                 <span style={{ color: '#F59E0B' }}>Please add more detail (min 10 chars)</span>
//               )}
//             </div>
//             {errors.desc && <span className="td-err">{errors.desc}</span>}
//           </div>
//         </div>
//       </Modal>
      
//       <ErrorModal 
//         isOpen={showErrorModal}
//         onClose={() => setShowErrorModal(false)}
//         title="Submission Failed"
//         message={errorMessage}
//       />
//     </>
//   )
// }

// // ─── Check In/Out Modal with Validations ────────────────────────────
// const CheckInOutModal = ({ onClose, onSubmit, tenantId, pgId, currentPG }) => {
//   const [reqType, setReqType] = useState('Check Out')
//   const [from, setFrom] = useState('')
//   const [to, setTo] = useState('')
//   const [contact, setContact] = useState('')
//   const [reason, setReason] = useState('')
//   const [loading, setLoading] = useState(false)
//   const [errors, setErrors] = useState({})
//   const [showErrorModal, setShowErrorModal] = useState(false)
//   const [errorMessage, setErrorMessage] = useState('')

//   const validateFromDate = (date) => {
//     if (!date) return 'From date is required'
//     const fromDate = new Date(date)
//     const today = new Date()
//     today.setHours(0, 0, 0, 0)
//     if (fromDate < today) return 'From date cannot be in the past'
//     return ''
//   }

//   const validateToDate = (toDate, fromDate) => {
//     if (!toDate) return 'To date is required'
//     const toDateObj = new Date(toDate)
//     const fromDateObj = new Date(fromDate)
//     const today = new Date()
//     today.setHours(0, 0, 0, 0)
    
//     if (toDateObj < today) return 'To date cannot be in the past'
//     if (fromDate && toDateObj < fromDateObj) return 'To date must be after from date'
//     return ''
//   }

//   const validateContact = (phone) => {
//     if (phone && phone.trim()) {
//       const phoneRegex = /^[0-9]{10}$/
//       if (!phoneRegex.test(phone.trim())) return 'Emergency contact must be exactly 10 digits'
//     }
//     return ''
//   }

//   const validateReason = (text) => {
//     if (text && text.trim()) {
//       if (text.length < 5) return 'Please provide a more detailed reason (min 5 characters)'
//       if (text.length > 500) return 'Reason must be less than 500 characters'
//     }
//     return ''
//   }

//   const handleFromChange = (value) => {
//     setFrom(value)
//     const error = validateFromDate(value)
//     setErrors(prev => ({ ...prev, from: error }))
//     if (to) {
//       const toError = validateToDate(to, value)
//       setErrors(prev => ({ ...prev, to: toError }))
//     }
//   }

//   const handleToChange = (value) => {
//     setTo(value)
//     const error = validateToDate(value, from)
//     setErrors(prev => ({ ...prev, to: error }))
//   }

//   const handleContactChange = (value) => {
//     const cleaned = value.replace(/[^0-9]/g, '').slice(0, 10)
//     setContact(cleaned)
//     const error = validateContact(cleaned)
//     setErrors(prev => ({ ...prev, contact: error }))
//   }

//   const handleReasonChange = (value) => {
//     setReason(value)
//     const error = validateReason(value)
//     setErrors(prev => ({ ...prev, reason: error }))
//   }

//   const days = from && to && !errors.from && !errors.to 
//     ? Math.max(0, Math.round((new Date(to) - new Date(from)) / 86400000))
//     : null

//   const validateForm = () => {
//     const newErrors = {}
//     const fromError = validateFromDate(from)
//     if (fromError) newErrors.from = fromError
//     const toError = validateToDate(to, from)
//     if (toError) newErrors.to = toError
//     const contactError = validateContact(contact)
//     if (contactError) newErrors.contact = contactError
//     const reasonError = validateReason(reason)
//     if (reasonError) newErrors.reason = reasonError
//     setErrors(newErrors)
//     return Object.keys(newErrors).length === 0
//   }

//   const submit = async () => {
//     if (!validateForm()) return

//     setLoading(true)
//     try {
//       const userId = parseInt(currentPG.nUserId || '0')

//       const result = await insertCompliance({
//         PGID: pgId,
//         TenantID: tenantId,
//         ComplianceType: reqType === 'Check Out' ? 'Check-Out' : 'Check-In',
//         ComplianceDetails: reason || `${reqType} request from ${from} to ${to}`,
//         DateRange: `${from} to ${to}`,
//         ActionTaken: null,
//         Status: 'PENDING',
//         UserId: userId
//       })

//       if (result && result.Success === 1) {
//         onSubmit({
//           type: 'checkinout',
//           title: `${reqType} Request`,
//           sub: `${from} → ${to}`,
//           status: 'PENDING',
//           date: new Date().toISOString()
//         })
//         onClose()
//       } else {
//         setErrorMessage(result?.Message || 'Failed to submit request')
//         setShowErrorModal(true)
//       }
//     } catch (error) {
//       console.error('Error submitting request:', error)
//       setErrorMessage('Failed to submit request. Please try again.')
//       setShowErrorModal(true)
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <>
//       <Modal title="New Check In / Check Out Request" onClose={onClose}
//         footer={<>
//           <button className="td-btn td-btn-outline" onClick={onClose}>Cancel</button>
//           <button className="td-btn td-btn-primary" onClick={submit} disabled={loading}>
//             {loading ? 'Submitting...' : 'Submit'}
//           </button>
//         </>}>
//         <div className="td-form-grid">
//           <div className="td-field td-field-half">
//             <label className="td-label">Request Type <span className="td-req">*</span></label>
//             <select className="td-select" value={reqType} onChange={e => setReqType(e.target.value)}>
//               <option value="Check Out">Check Out</option>
//               <option value="Check In">Check In</option>
//             </select>
//           </div>

//           <div className="td-field td-field-half" data-error-field="from">
//             <label className="td-label">From Date <span className="td-req">*</span></label>
//             <input
//               className={`td-input ${errors.from ? 'td-input-err' : ''}`}
//               type="date"
//               value={from}
//               onChange={e => handleFromChange(e.target.value)}
//               min={new Date().toISOString().split('T')[0]}
//             />
//             {errors.from && <span className="td-err">{errors.from}</span>}
//           </div>

//           <div className="td-field td-field-half" data-error-field="to">
//             <label className="td-label">To Date <span className="td-req">*</span></label>
//             <input
//               className={`td-input ${errors.to ? 'td-input-err' : ''}`}
//               type="date"
//               value={to}
//               onChange={e => handleToChange(e.target.value)}
//               min={from || new Date().toISOString().split('T')[0]}
//             />
//             {errors.to && <span className="td-err">{errors.to}</span>}
//           </div>

//           <div className="td-field td-field-half">
//             <label className="td-label">Number of Days</label>
//             <input 
//               className="td-input td-input-ro" 
//               readOnly 
//               value={days !== null && !errors.from && !errors.to 
//                 ? `${days} day${days !== 1 ? 's' : ''}` 
//                 : '—'} 
//             />
//             {from && to && !errors.from && !errors.to && days === 0 && (
//               <span className="td-err">Same day selected. This will be processed as a 1-day request</span>
//             )}
//           </div>

//           <div className="td-field td-field-half" data-error-field="contact">
//             <label className="td-label">Emergency Contact</label>
//             <input
//               className={`td-input ${errors.contact ? 'td-input-err' : ''}`}
//               type="tel"
//               placeholder="9999999999"
//               value={contact}
//               onChange={e => handleContactChange(e.target.value)}
//             />
//             <span className="td-hint">Optional, but recommended for emergency communication</span>
//             {errors.contact && <span className="td-err">{errors.contact}</span>}
//           </div>

//           <div className="td-field td-field-full" data-error-field="reason">
//             <label className="td-label">Reason</label>
//             <textarea
//               className={`td-textarea ${errors.reason ? 'td-input-err' : ''}`}
//               placeholder="e.g., Family function, Medical emergency, Vacation, Business travel..."
//               rows={3}
//               maxLength={500}
//               value={reason}
//               onChange={e => handleReasonChange(e.target.value)}
//             />
//             <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#9CA3AF', marginTop: '4px' }}>
//               <span>{reason.length}/500 characters</span>
//               {reason && reason.length < 5 && reason.length > 0 && (
//                 <span style={{ color: '#F59E0B' }}>Please add more detail (min 5 chars)</span>
//               )}
//             </div>
//             {errors.reason && <span className="td-err">{errors.reason}</span>}
//           </div>
//         </div>
//       </Modal>

//       <ErrorModal 
//         isOpen={showErrorModal}
//         onClose={() => setShowErrorModal(false)}
//         title="Submission Failed"
//         message={errorMessage}
//       />
//     </>
//   )
// }

// // ─── Visitor Modal with Validations ───────────────────────────────────
// const VisitorModal = ({ onClose, onSubmit, tenantId, pgId, currentPG }) => {
//   const [name, setName] = useState('')
//   const [rel, setRel] = useState('')
//   const [mobile, setMobile] = useState('')
//   const [arrival, setArrival] = useState('')
//   const [depart, setDepart] = useState('')
//   const [notes, setNotes] = useState('')
//   const [loading, setLoading] = useState(false)
//   const [errors, setErrors] = useState({})
//   const [showErrorModal, setShowErrorModal] = useState(false)
//   const [errorMessage, setErrorMessage] = useState('')

//   const validateName = (value) => {
//     if (!value || !value.trim()) return 'Visitor name is required'
//     if (value.length < 2) return 'Name must be at least 2 characters'
//     if (value.length > 100) return 'Name must be less than 100 characters'
//     if (!/^[a-zA-Z\s\-\.]+$/.test(value.trim())) return 'Name should only contain letters, spaces, hyphens, and dots'
//     return ''
//   }

//   const validateRelation = (value) => {
//     if (value && value.trim()) {
//       if (value.length > 50) return 'Relation must be less than 50 characters'
//       if (!/^[a-zA-Z\s\-\.]+$/.test(value.trim())) return 'Relation should only contain letters, spaces, hyphens, and dots'
//     }
//     return ''
//   }

//   const validateMobile = (value) => {
//     if (!value || !value.trim()) return 'Mobile number is required'
//     const phoneRegex = /^[0-9]{10}$/
//     if (!phoneRegex.test(value.trim())) return 'Mobile number must be exactly 10 digits'
//     return ''
//   }

//   const validateArrivalDate = (date) => {
//     if (!date) return 'Arrival date is required'
//     const arrivalDate = new Date(date)
//     const today = new Date()
//     today.setHours(0, 0, 0, 0)
//     if (arrivalDate < today) return 'Arrival date cannot be in the past'
//     return ''
//   }

//   const validateDepartureDate = (departDate, arrivalDate) => {
//     if (departDate && departDate.trim()) {
//       const departDateObj = new Date(departDate)
//       const arrivalDateObj = new Date(arrivalDate)
//       const today = new Date()
//       today.setHours(0, 0, 0, 0)
      
//       if (departDateObj < today) return 'Departure date cannot be in the past'
//       if (arrivalDate && departDateObj < arrivalDateObj) return 'Departure date must be after arrival date'
      
//       if (arrivalDate && (departDateObj - arrivalDateObj) / 86400000 > 30) {
//         return 'Visitor stay cannot exceed 30 days'
//       }
//     }
//     return ''
//   }

//   const validateNotes = (text) => {
//     if (text && text.trim()) {
//       if (text.length > 500) return 'Notes must be less than 500 characters'
//     }
//     return ''
//   }

//   const handleNameChange = (value) => {
//     setName(value)
//     const error = validateName(value)
//     setErrors(prev => ({ ...prev, name: error }))
//   }

//   const handleRelationChange = (value) => {
//     setRel(value)
//     const error = validateRelation(value)
//     setErrors(prev => ({ ...prev, relation: error }))
//   }

//   const handleMobileChange = (value) => {
//     const cleaned = value.replace(/[^0-9]/g, '').slice(0, 10)
//     setMobile(cleaned)
//     const error = validateMobile(cleaned)
//     setErrors(prev => ({ ...prev, mobile: error }))
//   }

//   const handleArrivalChange = (value) => {
//     setArrival(value)
//     const error = validateArrivalDate(value)
//     setErrors(prev => ({ ...prev, arrival: error }))
//     if (depart) {
//       const departError = validateDepartureDate(depart, value)
//       setErrors(prev => ({ ...prev, departure: departError }))
//     }
//   }

//   const handleDepartureChange = (value) => {
//     setDepart(value)
//     const error = validateDepartureDate(value, arrival)
//     setErrors(prev => ({ ...prev, departure: error }))
//   }

//   const handleNotesChange = (value) => {
//     setNotes(value)
//     const error = validateNotes(value)
//     setErrors(prev => ({ ...prev, notes: error }))
//   }

//   const days = arrival && depart && !errors.arrival && !errors.departure
//     ? Math.max(0, Math.round((new Date(depart) - new Date(arrival)) / 86400000))
//     : null

//   const validateForm = () => {
//     const newErrors = {}
//     const nameError = validateName(name)
//     if (nameError) newErrors.name = nameError
//     const relationError = validateRelation(rel)
//     if (relationError) newErrors.relation = relationError
//     const mobileError = validateMobile(mobile)
//     if (mobileError) newErrors.mobile = mobileError
//     const arrivalError = validateArrivalDate(arrival)
//     if (arrivalError) newErrors.arrival = arrivalError
//     const departureError = validateDepartureDate(depart, arrival)
//     if (departureError) newErrors.departure = departureError
//     const notesError = validateNotes(notes)
//     if (notesError) newErrors.notes = notesError
//     setErrors(newErrors)
//     return Object.keys(newErrors).length === 0
//   }

//   const submit = async () => {
//     if (!validateForm()) return

//     setLoading(true)
//     try {
//       const userId = parseInt(currentPG.nUserId || '0')

//       const result = await insertCompliance({
//         PGID: pgId,
//         TenantID: tenantId,
//         ComplianceType: 'Visitor',
//         ComplianceDetails: `Visitor: ${name} (${rel || 'Guest'}) | Mobile: ${mobile} | Purpose: ${notes || 'Not specified'}`,
//         DateRange: depart ? `${arrival} to ${depart}` : arrival,
//         ActionTaken: null,
//         Status: 'PENDING',
//         UserId: userId
//       })

//       if (result && result.Success === 1) {
//         onSubmit({
//           type: 'visitor',
//           title: `Visitor: ${name}`,
//           sub: rel || 'Guest',
//           status: 'PENDING',
//           date: new Date().toISOString()
//         })
//         onClose()
//       } else {
//         setErrorMessage(result?.Message || 'Failed to submit visitor request')
//         setShowErrorModal(true)
//       }
//     } catch (error) {
//       console.error('Error submitting visitor:', error)
//       setErrorMessage('Failed to submit visitor request. Please try again.')
//       setShowErrorModal(true)
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <>
//       <Modal title="New Visitor Request" onClose={onClose}
//         footer={<>
//           <button className="td-btn td-btn-outline" onClick={onClose}>Cancel</button>
//           <button className="td-btn td-btn-primary" onClick={submit} disabled={loading}>
//             {loading ? 'Submitting...' : 'Submit'}
//           </button>
//         </>}>
//         <div className="td-form-grid">
//           <div className="td-field td-field-half" data-error-field="name">
//             <label className="td-label">Visitor Name <span className="td-req">*</span></label>
//             <input
//               className={`td-input ${errors.name ? 'td-input-err' : ''}`}
//               type="text"
//               placeholder="Full name"
//               maxLength={100}
//               value={name}
//               onChange={e => handleNameChange(e.target.value)}
//             />
//             {errors.name && <span className="td-err">{errors.name}</span>}
//           </div>

//           <div className="td-field td-field-half" data-error-field="relation">
//             <label className="td-label">Relation</label>
//             <input
//               className={`td-input ${errors.relation ? 'td-input-err' : ''}`}
//               type="text"
//               placeholder="e.g. Father, Mother, Friend, Colleague"
//               maxLength={50}
//               value={rel}
//               onChange={e => handleRelationChange(e.target.value)}
//             />
//             {errors.relation && <span className="td-err">{errors.relation}</span>}
//           </div>

//           <div className="td-field td-field-half" data-error-field="mobile">
//             <label className="td-label">Mobile Number <span className="td-req">*</span></label>
//             <input
//               className={`td-input ${errors.mobile ? 'td-input-err' : ''}`}
//               type="tel"
//               placeholder="9999999999"
//               value={mobile}
//               onChange={e => handleMobileChange(e.target.value)}
//             />
//             {errors.mobile && <span className="td-err">{errors.mobile}</span>}
//           </div>

//           <div className="td-field td-field-half" data-error-field="arrival">
//             <label className="td-label">Arrival Date <span className="td-req">*</span></label>
//             <input
//               className={`td-input ${errors.arrival ? 'td-input-err' : ''}`}
//               type="date"
//               value={arrival}
//               onChange={e => handleArrivalChange(e.target.value)}
//               min={new Date().toISOString().split('T')[0]}
//             />
//             {errors.arrival && <span className="td-err">{errors.arrival}</span>}
//           </div>

//           <div className="td-field td-field-half" data-error-field="departure">
//             <label className="td-label">Departure Date</label>
//             <input
//               className={`td-input ${errors.departure ? 'td-input-err' : ''}`}
//               type="date"
//               value={depart}
//               onChange={e => handleDepartureChange(e.target.value)}
//               min={arrival || new Date().toISOString().split('T')[0]}
//             />
//             {errors.departure && <span className="td-err">{errors.departure}</span>}
//             <span className="td-hint">Leave empty for day visit</span>
//           </div>

//           <div className="td-field td-field-half">
//             <label className="td-label">Number of Days</label>
//             <input
//               className="td-input td-input-ro"
//               readOnly
//               value={days !== null && !errors.arrival && !errors.departure
//                 ? `${days} day${days !== 1 ? 's' : ''}`
//                 : arrival && !errors.arrival && !depart ? 'Day visit' : '—'}
//             />
//             {arrival && !depart && !errors.arrival && (
//               <span className="td-hint" style={{ color: '#F59E0B' }}>No departure date set - day visit</span>
//             )}
//             {days === 0 && arrival && depart && !errors.arrival && !errors.departure && (
//               <span className="td-hint" style={{ color: '#F59E0B' }}>Same day selected - day visit</span>
//             )}
//           </div>

//           <div className="td-field td-field-full" data-error-field="notes">
//             <label className="td-label">Purpose / Notes</label>
//             <textarea
//               className={`td-textarea ${errors.notes ? 'td-input-err' : ''}`}
//               placeholder="Purpose of visit (e.g., Family function, Overnight stay, Weekend visit, Business meeting...)"
//               rows={3}
//               maxLength={500}
//               value={notes}
//               onChange={e => handleNotesChange(e.target.value)}
//             />
//             <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#9CA3AF', marginTop: '4px' }}>
//               <span>{notes.length}/500 characters</span>
//             </div>
//             {errors.notes && <span className="td-err">{errors.notes}</span>}
//           </div>
//         </div>
//       </Modal>

//       <ErrorModal 
//         isOpen={showErrorModal}
//         onClose={() => setShowErrorModal(false)}
//         title="Submission Failed"
//         message={errorMessage}
//       />
//     </>
//   )
// }

// // ─── Agreement Modal ──────────────────────────────────────────────
// const AgreementModal = ({ onClose, onComingSoon, currentPG }) => {
//   return (
//     <Modal title="Rental Agreement" onClose={onClose}
//       footer={
//         <button className="td-btn td-btn-primary" onClick={() => {
//           onClose()
//           onComingSoon()
//         }}>
//           {Icon.download} Download
//         </button>
//       }>
//       <div className="td-agreement">
//         <div className="td-agr-badge">
//           <span className="td-agr-icon">{Icon.doc}</span>
//           <div>
//             <span className="td-agr-name">Rental Agreement</span>
//             <span className="td-agr-status">● {currentPG.Status || 'Active'}</span>
//           </div>
//         </div>
//         <div className="td-agr-grid">
//           {[
//             ['Tenant Name', currentPG.TenantName || '—'],
//             ['PG Name', `${currentPG.PGName || 'PG'} (${currentPG.PGCode || '—'})`],
//             ['Room / Bed', `${currentPG.RoomNumber || '—'} / ${currentPG.BedNumber || '—'}`],
//             ['Floor', currentPG.Floor || '—'],
//             ['Room Type', currentPG.RoomType || '—'],
//             ['Start Date', currentPG.JoiningDate ? new Date(currentPG.JoiningDate).toLocaleDateString() : '—'],
//             ['End Date', currentPG.CheckOutDate ? new Date(currentPG.CheckOutDate).toLocaleDateString() : 'Ongoing'],
//             ['Rent Amount', `₹${(currentPG.NetPayable || currentPG.RentAmount || 0).toLocaleString()}/month`],
//             ['Security Deposit', `₹${((currentPG.NetPayable || currentPG.RentAmount || 0) * 2).toLocaleString()}`],
//             ['Agreement Status', currentPG.Status || 'Active'],
//           ].map(([l, v]) => (
//             <div key={l} className="td-agr-field">
//               <span className="td-agr-label">{l}</span>
//               <span className="td-agr-value">{v}</span>
//             </div>
//           ))}
//         </div>
//       </div>
//     </Modal>
//   )
// }

// // ─── Status Badge ─────────────────────────────────────────────────
// const StatusBadge = ({ status }) => {
//   const cfg = STATUS_CFG[status?.toUpperCase()] || STATUS_CFG.PENDING
//   return (
//     <span className="td-status-badge" style={{ background: cfg.bg, color: cfg.text, borderColor: cfg.border }}>
//       <span className="td-status-dot" style={{ background: cfg.dot }} />
//       {cfg.label}
//     </span>
//   )
// }

// // ─── Activity Icon ────────────────────────────────────────────────
// const ActivityIcon = ({ type }) => {
//   const cfg = TYPE_CFG[type]
//   if (!cfg) return null
//   return (
//     <span className="td-act-icon" style={{ background: cfg.bg, color: cfg.color }}>
//       {type === 'complaint' ? Icon.complaint : type === 'visitor' ? Icon.visitor : Icon.calendar}
//     </span>
//   )
// }

// // ─── Activity Accordion ───────────────────────────────────────────
// const ActivityAccordion = ({ month, items, defaultOpen }) => {
//   const [open, setOpen] = useState(defaultOpen)
//   return (
//     <div className="td-acc-item">
//       <button className="td-acc-head" onClick={() => setOpen(p => !p)}>
//         <span className="td-acc-month">{month} <span className="td-acc-count">({items.length})</span></span>
//         <span className={`td-acc-chevron ${open ? 'open' : ''}`}>{Icon.chevDown}</span>
//       </button>
//       {open && (
//         <div className="td-acc-body">
//           {items.map((a, idx) => (
//             <div key={idx} className="td-act-row">
//               <ActivityIcon type={a.type} />
//               <div className="td-act-info">
//                 <span className="td-act-title">{a.title}</span>
//                 <span className="td-act-meta">
//                   <span className="td-act-type-pill" style={{ color: TYPE_CFG[a.type]?.color, background: TYPE_CFG[a.type]?.bg }}>
//                     {TYPE_CFG[a.type]?.label}
//                   </span>
//                   · {a.sub} · {formatDate(a.date)}
//                 </span>
//               </div>
//               <StatusBadge status={a.status} />
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   )
// }

// // ─── Quick Action Card ────────────────────────────────────────────
// const ActionCard = ({ icon, label, color, bg, onClick }) => (
//   <button className="td-action-card" onClick={onClick}>
//     <span className="td-action-icon" style={{ background: bg, color }}>{icon}</span>
//     <span className="td-action-label">{label}</span>
//   </button>
// )

// // ─── Stat Card ────────────────────────────────────────────────────
// const StatCard = ({ icon, label, value, valueClass }) => (
//   <div className="td-stat-card">
//     <div className="td-stat-top">
//       <span className="td-stat-icon-wrap">{icon}</span>
//       <span className="td-stat-label">{label}</span>
//     </div>
//     <span className={`td-stat-value ${valueClass || ''}`}>{value}</span>
//   </div>
// )

// // ─── STATUS_CFG and TYPE_CFG ──────────────────────────────────────
// const STATUS_CFG = {
//   PENDING: { label: 'Pending', bg: '#FFF7ED', text: '#C2410C', border: '#FED7AA', dot: '#F97316' },
//   IN_PROGRESS: { label: 'In Progress', bg: '#EFF6FF', text: '#1D4ED8', border: '#BFDBFE', dot: '#3B82F6' },
//   APPROVED: { label: 'Approved', bg: '#F0FDF4', text: '#166534', border: '#86EFAC', dot: '#22C55E' },
//   RESOLVED: { label: 'Resolved', bg: '#F3F4F6', text: '#6B7280', border: '#E5E7EB', dot: '#9CA3AF' },
//   COMPLETED: { label: 'Completed', bg: '#F0FDF4', text: '#166534', border: '#86EFAC', dot: '#22C55E' },
//   REJECTED: { label: 'Rejected', bg: '#FFF1F2', text: '#991B1B', border: '#FECACA', dot: '#EF4444' },
//   OPEN: { label: 'Open', bg: '#FFF7ED', text: '#C2410C', border: '#FED7AA', dot: '#F97316' },
// }

// const TYPE_CFG = {
//   complaint: { label: 'Complaint', color: '#EF4444', bg: '#FFF1F2' },
//   visitor: { label: 'Visitor', color: '#6366F1', bg: '#EEF2FF' },
//   checkinout: { label: 'Check In/Out', color: '#0EA5E9', bg: '#F0F9FF' },
//   noticeperiod: { label: 'Notice Period', color: '#D97706', bg: '#FFFBEB' },
// }



// // ─── Notice Period Modal ───────────────────────────────────────────
// const NoticePeriodModal = ({ onClose, onSubmit, tenantId, pgId, currentPG }) => {
//   const [noticeType, setNoticeType] = useState('standard') // 'standard' | 'short'
//   const [shortDate, setShortDate] = useState('')
//   const [reason, setReason] = useState('')
//   const [errors, setErrors] = useState({})
//   const [showDeductionConfirm, setShowDeductionConfirm] = useState(false)
//   const [isSubmitting, setIsSubmitting] = useState(false)

//   // Notice period length as configured for this PG (falls back to 30 days if not set on the record)
//   const noticePeriodDays = currentPG.NoticePeriodDays || currentPG.NoticePeriod || 30

//   // ✅ FIXED: Use manual date formatting to avoid timezone issues
//   const getTodayDateStr = () => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   const addDaysToDateStr = (dateStr, days) => {
//     const [year, month, day] = dateStr.split('-').map(Number);
//     const date = new Date(year, month - 1, day + days);
//     const y = date.getFullYear();
//     const m = String(date.getMonth() + 1).padStart(2, '0');
//     const d = String(date.getDate()).padStart(2, '0');
//     return `${y}-${m}-${d}`;
//   };

  
//   // const today = getTodayDateOnly()
//   // const standardDate = addDays(today, noticePeriodDays)
//   // const todayStr = toDateInputValue(today)
//   // const standardDateStr = toDateInputValue(standardDate)

//    const todayStr = getTodayDateStr();
//   const standardDateStr = addDaysToDateStr(todayStr, noticePeriodDays);


//   const formatDateDisplay = (dateStr) => {
//     if (!dateStr) return 'N/A';
//     const [year, month, day] = dateStr.split('-').map(Number);
//     const date = new Date(year, month - 1, day);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   const validateShortDate = (date) => {
//     if (!date) return 'Please select a vacate date'
//     const d = new Date(date)
//     if (d < today) return 'Date cannot be in the past'
//     if (d > standardDate) return `Date must be within your ${noticePeriodDays}-day notice period`
//     return ''
//   }

//   const handleShortDateChange = (value) => {
//     setShortDate(value)
//     setErrors(prev => ({ ...prev, shortDate: validateShortDate(value) }))
//   }

//   // API call to submit notice
//   const submitRequest = async (vacateDateStr, isShort) => {
    
//     if(currentPG.AdmissionId == null) {
//       alert('Active admission not found. Please contact support.')
//       return
//     }
//     setIsSubmitting(true)
    
//     try {
//       // Prepare the data for API
//       const noticeData = {
//         AdmissionID: parseInt(currentPG.AdmissionId),
//         PGID: parseInt(pgId),
//         NoticeDate: todayStr, // Today's date
//         VacateDate: vacateDateStr,
//         NoticeReason: reason || (isShort ? 'Short notice request' : 'Standard notice request')
//       }
//       console.log('currentPG.AdmissionId:', currentPG.AdmissionId)
//       console.log('Submitting notice data:', noticeData)
//       // Call the API
//       const response = await tenantNoticeInsert(noticeData)
      
//       if (response && response.success) {
//         // Update local activity feed
//         onSubmit({
//           type: 'noticeperiod',
//           title: isShort ? 'Short Notice Period Request' : 'Notice Period Request',
//           // sub: `Vacate on ${formatDate(vacateDateStr)}`,
//           sub: `Vacate on ${formatDateDisplay(vacateDateStr)}`,
//           status: 'PENDING',
//           date: new Date().toISOString(),
//           noticeId: response.data?.NoticeID || null
//         })
        
//         setShowDeductionConfirm(false)
//         onClose()
        
//         // Optional: Show success message
//         // You can add a toast notification here if you have one
//         console.log('Notice submitted successfully:', response.message)
//         // If you have a toast system:
//         // showToast(response.message || 'Notice submitted successfully!', 'success')
//       }
//     } catch (error) {
//       console.error('Error submitting notice:', error)
      
//       // Handle specific error cases
//       let errorMessage = 'Failed to submit notice request. Please try again.'
      
//       if (error.message && error.message.includes('Active Admission not found')) {
//         errorMessage = 'Active admission not found. Please contact support.'
//       } else if (error.message && error.message.includes('Notice request already exists')) {
//         errorMessage = 'A notice request already exists for this tenant. Please check your pending requests.'
//       } else if (error.response?.data?.message) {
//         errorMessage = error.response.data.message
//       }
      
//       // Show error message
//       alert(errorMessage)
//       // If you have a toast system:
//       // showToast(errorMessage, 'error')
//     } finally {
//       setIsSubmitting(false)
//     }
//   }

//   const handleSubmitClick = () => {
//     if (noticeType === 'standard') {
//       submitRequest(standardDateStr, false)
//       return
//     }
//     const err = validateShortDate(shortDate)
//     setErrors(prev => ({ ...prev, shortDate: err }))
//     if (err) return
//     setShowDeductionConfirm(true)
//   }

//   const handleConfirmDeduction = () => {
//     submitRequest(shortDate, true)
//   }

//   return (
//     <>
//       <Modal
//         title="Notice Period Request"
//         onClose={onClose}
//         footer={<>
//           <button 
//             className="td-btn td-btn-outline" 
//             onClick={onClose} 
//             disabled={isSubmitting}
//           >
//             Cancel
//           </button>
//           <button
//             className="td-btn td-btn-primary"
//             onClick={handleSubmitClick}
//             disabled={isSubmitting || (noticeType === 'short' && !shortDate)}
//           >
//             {isSubmitting ? 'Submitting...' : 'Submit'}
//           </button>
//         </>}
//       >
//         <div className="td-toggle-group">
//           <button
//             type="button"
//             className={`td-toggle-btn ${noticeType === 'standard' ? 'active' : ''}`}
//             onClick={() => setNoticeType('standard')}
//             disabled={isSubmitting}
//           >
//             Standard Notice
//           </button>
//           <button
//             type="button"
//             className={`td-toggle-btn ${noticeType === 'short' ? 'active' : ''}`}
//             onClick={() => setNoticeType('short')}
//             disabled={isSubmitting}
//           >
//             Short Notice
//           </button>
//         </div>

//         {noticeType === 'standard' ? (
//           <div className="td-notice-info-card">
//             <span className="td-notice-info-icon">{Icon.calendar}</span>
//             <div className="td-notice-info-text">
//               <p className="td-notice-info-title">Your PG requires {noticePeriodDays} days' notice</p>
//               <p className="td-notice-info-sub">
//                 Based on today, {formatDateDisplay(todayStr)}, your notice period will end on <strong>{formatDateDisplay(standardDateStr)}</strong>. This will be your vacate date.
//               </p>
//             </div>
//           </div>
//         ) : (
//           <>
//             <div className="td-field td-field-full" data-error-field="shortDate">
//               <label className="td-label">Preferred Vacate Date <span className="td-req">*</span></label>
//               <input
//                 className={`td-input ${errors.shortDate ? 'td-input-err' : ''}`}
//                 type="date"
//                 value={shortDate}
//                 min={todayStr}
//                 max={standardDateStr}
//                 onChange={e => handleShortDateChange(e.target.value)}
//                 disabled={isSubmitting}
//               />
//               <span className="td-hint">
//                 Select any date between {formatDateDisplay(todayStr)} and {formatDateDisplay(standardDateStr)}, as per your PG's notice period policy.
//               </span>
//               {errors.shortDate && <span className="td-err">{errors.shortDate}</span>}
//             </div>

//             <div className="td-notice-warning-banner">
//               {Icon.alert}
//               <span>Vacating before your standard notice period ends will result in a deduction from your security deposit.</span>
//             </div>
//           </>
//         )}

//         <div className="td-field td-field-full" style={{ marginTop: 14 }}>
//           <label className="td-label">Reason (optional)</label>
//           <textarea
//             className="td-textarea"
//             placeholder="e.g., Job relocation, personal reasons..."
//             rows={3}
//             maxLength={500}
//             value={reason}
//             onChange={e => setReason(e.target.value)}
//             disabled={isSubmitting}
//           />
//         </div>
//       </Modal>

//       {showDeductionConfirm && (
//         <SecurityDeductionConfirmModal
//           onClose={() => setShowDeductionConfirm(false)}
//           onConfirm={handleConfirmDeduction}
//           vacateDate={formatDateDisplay(shortDate)}
//           isSubmitting={isSubmitting}
//         />
//       )}
//     </>
//   )
// }

// // const NoticePeriodModal = ({ onClose, onSubmit, tenantId, pgId, currentPG }) => {
// //   const [noticeType, setNoticeType] = useState('standard') // 'standard' | 'short'
// //   const [shortDate, setShortDate] = useState('')
// //   const [reason, setReason] = useState('')
// //   const [errors, setErrors] = useState({})
// //   const [showDeductionConfirm, setShowDeductionConfirm] = useState(false)

// //   // Notice period length as configured for this PG (falls back to 30 days if not set on the record)
// //   const noticePeriodDays = currentPG.NoticePeriodDays || currentPG.NoticePeriod || 30

// //   const today = getTodayDateOnly()
// //   const standardDate = addDays(today, noticePeriodDays)
// //   const todayStr = toDateInputValue(today)
// //   const standardDateStr = toDateInputValue(standardDate)

// //   const validateShortDate = (date) => {
// //     if (!date) return 'Please select a vacate date'
// //     const d = new Date(date)
// //     if (d < today) return 'Date cannot be in the past'
// //     if (d > standardDate) return `Date must be within your ${noticePeriodDays}-day notice period`
// //     return ''
// //   }

// //   const handleShortDateChange = (value) => {
// //     setShortDate(value)
// //     setErrors(prev => ({ ...prev, shortDate: validateShortDate(value) }))
// //   }

// //   // Static/local only — no backend call. Builds an activity entry for the
// //   // in-memory activity feed and closes the modal. Swap this out for a real
// //   // API call once a notice-period endpoint exists.
// //   const submitRequest = (vacateDateStr, isShort) => {
// //     onSubmit({
// //       type: 'noticeperiod',
// //       title: isShort ? 'Short Notice Period Request' : 'Notice Period Request',
// //       sub: `Vacate on ${formatDate(vacateDateStr)}`,
// //       status: 'PENDING',
// //       date: new Date().toISOString()
// //     })
// //     setShowDeductionConfirm(false)
// //     onClose()
// //   }

// //   const handleSubmitClick = () => {
// //     if (noticeType === 'standard') {
// //       submitRequest(standardDateStr, false)
// //       return
// //     }
// //     const err = validateShortDate(shortDate)
// //     setErrors(prev => ({ ...prev, shortDate: err }))
// //     if (err) return
// //     setShowDeductionConfirm(true)
// //   }

// //   const handleConfirmDeduction = () => {
// //     submitRequest(shortDate, true)
// //   }

// //   return (
// //     <>
// //       <Modal
// //         title="Notice Period Request"
// //         onClose={onClose}
// //         footer={<>
// //           <button className="td-btn td-btn-outline" onClick={onClose}>Cancel</button>
// //           <button
// //             className="td-btn td-btn-primary"
// //             onClick={handleSubmitClick}
// //             disabled={noticeType === 'short' && !shortDate}
// //           >
// //             Submit
// //           </button>
// //         </>}
// //       >
// //         <div className="td-toggle-group">
// //           <button
// //             type="button"
// //             className={`td-toggle-btn ${noticeType === 'standard' ? 'active' : ''}`}
// //             onClick={() => setNoticeType('standard')}
// //           >
// //             Standard Notice
// //           </button>
// //           <button
// //             type="button"
// //             className={`td-toggle-btn ${noticeType === 'short' ? 'active' : ''}`}
// //             onClick={() => setNoticeType('short')}
// //           >
// //             Short Notice
// //           </button>
// //         </div>

// //         {noticeType === 'standard' ? (
// //           <div className="td-notice-info-card">
// //             <span className="td-notice-info-icon">{Icon.calendar}</span>
// //             <div className="td-notice-info-text">
// //               <p className="td-notice-info-title">Your PG requires {noticePeriodDays} days' notice</p>
// //               <p className="td-notice-info-sub">
// //                 Based on today, {formatDate(todayStr)}, your notice period will end on <strong>{formatDate(standardDateStr)}</strong>. This will be your vacate date.
// //               </p>
// //             </div>
// //           </div>
// //         ) : (
// //           <>
// //             <div className="td-field td-field-full" data-error-field="shortDate">
// //               <label className="td-label">Preferred Vacate Date <span className="td-req">*</span></label>
// //               <input
// //                 className={`td-input ${errors.shortDate ? 'td-input-err' : ''}`}
// //                 type="date"
// //                 value={shortDate}
// //                 min={todayStr}
// //                 max={standardDateStr}
// //                 onChange={e => handleShortDateChange(e.target.value)}
// //               />
// //               <span className="td-hint">
// //                 Select any date between {formatDate(todayStr)} and {formatDate(standardDateStr)}, as per your PG's notice period policy.
// //               </span>
// //               {errors.shortDate && <span className="td-err">{errors.shortDate}</span>}
// //             </div>

// //             <div className="td-notice-warning-banner">
// //               {Icon.alert}
// //               <span>Vacating before your standard notice period ends will result in a deduction from your security deposit.</span>
// //             </div>
// //           </>
// //         )}

// //         {/* <div className="td-field td-field-full" style={{ marginTop: 14 }}>
// //           <label className="td-label">Reason (optional)</label>
// //           <textarea
// //             className="td-textarea"
// //             placeholder="e.g., Job relocation, personal reasons..."
// //             rows={3}
// //             maxLength={500}
// //             value={reason}
// //             onChange={e => setReason(e.target.value)}
// //           />
// //         </div> */}
// //       </Modal>

// //       {showDeductionConfirm && (
// //         <SecurityDeductionConfirmModal
// //           onClose={() => setShowDeductionConfirm(false)}
// //           onConfirm={handleConfirmDeduction}
// //           vacateDate={formatDate(shortDate)}
// //         />
// //       )}
// //     </>
// //   )
// // }

// // ─── Food Menu Modal (Read-Only) ────────────────────────────────────

// const FoodMenuModal = ({ isOpen, onClose, selectedPG }) => {
//   const [weekMenu, setWeekMenu] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (isOpen && selectedPG) {
//       fetchWeeklyMenu();
//     }
//   }, [isOpen, selectedPG]);

//   const fetchWeeklyMenu = async () => {
//     if (!selectedPG?.PGID) return;

//     setLoading(true);
//     setError("");
    
//     try {
//       const today = getTodayIST();
//       const response = await getWeeklyFoodMenu(selectedPG.PGID, today);
//       console.log("Weekly menu response:", response);

//       const todayDate = parseDate(today);
//       const todayDow = todayDate.getDay();

//       const mondayOffset = (todayDow === 0) ? -6 : 1 - todayDow;
//       const mondayDate = new Date(todayDate);
//       mondayDate.setDate(todayDate.getDate() + mondayOffset);

//       const weekArray = [];
//       const weekMap = {};

//       for (let i = 0; i < 7; i++) {
//         const date = new Date(mondayDate);
//         date.setDate(mondayDate.getDate() + i);
        
//         const yyyy = date.getFullYear();
//         const mm = String(date.getMonth() + 1).padStart(2, "0");
//         const dd = String(date.getDate()).padStart(2, "0");
//         const dateStr = `${yyyy}-${mm}-${dd}`;
//         const dayName = DAY_FULL[i];

//         const dayData = {
//           date: dateStr,
//           day: DAY_ABBR[i],
//           fullDay: dayName,
//           isToday: dateStr === today,
//           items: {
//             breakfast: [],
//             lunch: [],
//             tea: [],
//             dinner: [],
//           }
//         };

//         weekArray.push(dayData);
//         weekMap[dateStr] = dayData;
//         weekMap[dayName] = dayData;
//       }

//       if (response && response.data && response.data.weeklyMenu) {
//         const weeklyData = response.data.weeklyMenu;
        
//         weeklyData.forEach((item) => {
//           const dayName = item.dayName;
//           const mealType = item.mealType.toLowerCase();
//           const dayData = weekMap[dayName];
          
//           if (dayData) {
//             const items = [];
//             if (item.item1) items.push(item.item1);
//             if (item.item2) items.push(item.item2);
//             if (item.item3) items.push(item.item3);
//             if (item.item4) items.push(item.item4);
            
//             let mealKey = mealType;
//             if (mealType === 'breakfast') mealKey = 'breakfast';
//             else if (mealType === 'lunch') mealKey = 'lunch';
//             else if (mealType === 'tea') mealKey = 'tea';
//             else if (mealType === 'dinner') mealKey = 'dinner';
            
//             dayData.items[mealKey] = items;
//           }
//         });
//       }

//       setWeekMenu(weekArray);
//     } catch (err) {
//       console.error("Error fetching weekly menu:", err);
//       setError("Failed to load weekly menu. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   const formatDateToDDMMYYYY = (dateStr) => {
//     if (!dateStr) return "";
//     try {
//       const date = new Date(dateStr);
//       if (isNaN(date.getTime())) return "";
//       const day = String(date.getDate()).padStart(2, '0');
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (e) {
//       return "";
//     }
//   };

//   const renderWeeklyTableView = () => (
//     <div className="td-food-table-wrapper">
//       <table className="td-food-table">
//         <thead>
//           <tr>
//             <th className="td-food-meal-header">Meal</th>
//             {weekMenu.map((day) => (
//               <th key={day.date} className={day.isToday ? 'today' : ''}>
//                 <span className="td-food-th-day">{day.day}</span>
//                 {day.isToday ? (
//                   <span className="td-today-badge">Today</span>
//                 ) : (
//                   // <span className="td-food-th-date">{formatDateToDDMMYYYY(day.date)}</span>
//                   null
//                 )}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {[
//             { key: 'breakfast', label: 'Breakfast', icon: '🌅' },
//             { key: 'lunch', label: 'Lunch', icon: '☀️' },
//             { key: 'tea', label: 'Tea', icon: '🍵' },
//             { key: 'dinner', label: 'Dinner', icon: '🌙' },
//           ].map((meal) => (
//             <tr key={meal.key}>
//               <td className="td-food-meal-label">
//                 <span>{meal.icon}</span> {meal.label}
//               </td>
//               {weekMenu.map((day) => (
//                 <td key={day.date} className={`td-food-cell ${day.isToday ? 'today' : ''}`}>
//                   <div className="td-food-cell-inner">
//                     {day.items?.[meal.key]?.length > 0 ? (
//                       <ol className="td-food-items-list">
//                         {day.items[meal.key].map((item, i) => (
//                           <li key={i}>{item}</li>
//                         ))}
//                       </ol>
//                     ) : (
//                       <span className="td-food-empty">—</span>
//                     )}
//                   </div>
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );

//   const renderMobileCardView = () => (
//     <div className="td-food-mobile">
//       {weekMenu.map((day) => (
//         <div key={day.date} className={`td-food-card ${day.isToday ? 'today' : ''}`}>
//           <div className="td-food-card-header">
//             <div>
//               <span className="td-food-card-day">{day.day}</span>
//               {day.isToday && <span className="td-today-badge">Today</span>}
//             </div>
//             <span className="td-food-card-date">{formatDateToDDMMYYYY(day.date)}</span>
//           </div>
//           <div className="td-food-card-body">
//             {[
//               { key: 'breakfast', label: 'Breakfast', icon: '🌅' },
//               { key: 'lunch', label: 'Lunch', icon: '☀️' },
//               { key: 'tea', label: 'Tea', icon: '🍵' },
//               { key: 'dinner', label: 'Dinner', icon: '🌙' },
//             ].map((meal) => (
//               <div className="td-food-card-meal-row" key={meal.key}>
//                 <div className="td-food-card-meal-label">
//                   <span>{meal.icon}</span> {meal.label}
//                 </div>
//                 <div className="td-food-card-meal-value">
//                   {day.items?.[meal.key]?.length > 0 ? (
//                     <ol className="td-food-items-list">
//                       {day.items[meal.key].map((item, i) => (
//                         <li key={i}>{item}</li>
//                       ))}
//                     </ol>
//                   ) : (
//                     <span className="td-food-empty">—</span>
//                   )}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       ))}
//     </div>
//   );

//   return (
//     <div className="td-food-overlay" onClick={onClose}>
//       <div className="td-food-modal-container" onClick={(e) => e.stopPropagation()}>
//         <div className="td-food-modal-header">
//           <div>
//             <h3 className="td-food-modal-title">Weekly Food Menu</h3>
//             <p className="td-food-modal-sub">{selectedPG?.PGName || "Weekly meal plan"}</p>
//           </div>
//           <button className="td-food-modal-close" onClick={onClose}>
//             <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
//               <path d="M1 1L17 17M17 1L1 17" stroke="#374151" strokeWidth="2" strokeLinecap="round" />
//             </svg>
//           </button>
//         </div>

//         <div className="td-food-modal-body">
//           <div className="td-food-toolbar">
//             <span className="td-food-days-count">
//               📅 Monday – Sunday · today's column is highlighted
//             </span>
//           </div>

//           {loading && (
//             <div className="td-food-loading">
//               <div className="td-food-spinner"></div>
//               <p>Loading menu...</p>
//             </div>
//           )}

//           {error && (
//             <p className="td-food-error">{error}</p>
//           )}

//           {!loading && !error && weekMenu.length > 0 && (
//             <>
//               <div className="td-food-desktop">
//                 {renderWeeklyTableView()}
//               </div>
//               <div className="td-food-mobile-view">
//                 {renderMobileCardView()}
//               </div>
//             </>
//           )}

//           {!loading && !error && weekMenu.length === 0 && (
//             <div className="td-food-empty-state">
//               <p>No menu items found for this week.</p>
//             </div>
//           )}
//         </div>

//         <div className="td-food-modal-footer">
//           <button className="td-food-close-btn" onClick={onClose}>
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Helper function for today's date ────────────────────────────────────
// const getTodayIST = () => {
//   const now = new Date();
//   const ist = new Date(
//     now.toLocaleString("en-US", {
//       timeZone: "Asia/Kolkata",
//     })
//   );
//   const yyyy = ist.getFullYear();
//   const mm = String(ist.getMonth() + 1).padStart(2, "0");
//   const dd = String(ist.getDate()).padStart(2, "0");
//   return `${yyyy}-${mm}-${dd}`;
// };

// const parseDate = (dateStr) => {
//   if (!dateStr) return new Date();
//   const [yyyy, mm, dd] = dateStr.split("-").map(Number);
//   return new Date(yyyy, mm - 1, dd);
// };

// // const DAY_ABBR = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// // const DAY_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
// const DAY_ABBR = [ "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
// const DAY_FULL = [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday","Sunday"];



// // ─── TENANT DASHBOARD ─────────────────────────────────────────────
// const TenantDashboard = () => {
//   const navigate = useNavigate()
//   const { logout, user, userDataList, updateTenantProfile } = useAuth()

//   // userDataList contains all PG data for the tenant
//   const tenantPGs = userDataList || []
// console.log("userDataList", userDataList)
//   // Set default selected PG index (first one)
//   const [selectedPGIndex, setSelectedPGIndex] = useState(0)

//   // Get current PG data based on selected index
//   const currentPG = tenantPGs[selectedPGIndex] || {}
// console.log("currentPG", currentPG);

//   // Derive tenant data from current PG
//   const tenantId = currentPG.TenantID
//   const pgId = currentPG.PGID
//   const tenantName = currentPG.TenantName || 'Tenant'
//   const tenantInitials = tenantName.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)

//   // Construct Room display string
//   const roomDisplay = currentPG.RoomNumber && currentPG.BedNumber 
//     ? `Room ${currentPG.RoomNumber} (Bed ${currentPG.BedNumber}) - ${currentPG.Floor || ''}`
//     : currentPG.RoomNumber 
//       ? `Room ${currentPG.RoomNumber}` 
//       : '—'

//   // Construct PG display string
//   const pgDisplay = currentPG.PGName && currentPG.PGCode
//     ? `${currentPG.PGName} (${currentPG.PGCode})`
//     : currentPG.PGName || `PG #${pgId || '—'}`

//   // Rent amount from NetPayable
//   const rentAmount = currentPG.NetPayable  || 0

//   const [notifOpen, setNotifOpen] = useState(false)
//   const [profileOpen, setProfileOpen] = useState(false)
//   const [modal, setModal] = useState(null)
//   const [activities, setActivities] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [openMonths, setOpenMonths] = useState({})
//   const [showLogoutModal, setShowLogoutModal] = useState(false)
//   const [showNoPGWarning, setShowNoPGWarning] = useState(false)
//   const [showComingSoon, setShowComingSoon] = useState(false)
//   const [showSuccessModal, setShowSuccessModal] = useState(false)
//   const [successMessage, setSuccessMessage] = useState('')
//   const [showErrorModal, setShowErrorModal] = useState(false)
//   const [errorMessage, setErrorMessage] = useState('')

//   const [foodMenuOpen, setFoodMenuOpen] = useState(false);
  

//   useEffect(() => {
//     if (tenantId && pgId && !hasNoPG) {
//       fetchActivities()
//     } else {
//       setLoading(false)
//     }
//   }, [tenantId, pgId, selectedPGIndex])

 

//   const fetchActivities = async () => {
//     setLoading(true)
//     try {
//       const complaints = await getComplaintsByTenantId(tenantId)
//       const complaintActivities = (complaints || []).map(c => ({
//         type: 'complaint',
//         title: c.ComplaintText,
//         sub: c.ComplaintText?.split(':')[0] || 'Complaint',
//         status: c.ComplaintStatus,
//         date: c.ComplaintDate
//       }))

//       const compliance = await GetComplianceByTenant(tenantId)
//       const tenantCompliance = (compliance || []).filter(c => c.TenantID === tenantId)
//       const complianceActivities = tenantCompliance.map(c => {
//         let type = 'visitor'
//         if (c.ComplianceType?.toLowerCase().includes('check') || c.ComplianceType?.toLowerCase().includes('in/out')) {
//           type = 'checkinout'
//         }
//         return {
//           type: type,
//           title: c.Title || c.ComplianceType,
//           sub: c.ComplianceDetails || c.DateRange || '',
//           status: c.Status,
//           date: c.CreatedDate
//         }
//       })

//       const allActivities = [...complaintActivities, ...complianceActivities]
//         .sort((a, b) => new Date(b.date) - new Date(a.date))

//       setActivities(allActivities)
//     } catch (error) {
//       console.error('Error fetching activities:', error)
//       setErrorMessage('Failed to load activities. Please refresh the page.')
//       setShowErrorModal(true)
//     } finally {
//       setLoading(false)
//     }
//   }


//   const hasNoPG = !tenantId || !pgId || tenantPGs.length === 0
//    useEffect(() => {
//     if (hasNoPG) {
//       setShowNoPGWarning(true)
//     }
//   }, [hasNoPG])

//   const handleActivitySubmit = (data) => {
//     const newActivity = {
//       ...data,
//       id: Date.now()
//     }
//     setActivities(prev => [newActivity, ...prev])
//     const month = getMonthYear(data.date)
//     setOpenMonths(prev => ({ ...prev, [month]: true }))
//     fetchActivities()
    
//     let successMsg = ''
//     if (data.type === 'complaint') successMsg = 'Your complaint has been submitted successfully. The admin will review it shortly.'
//     else if (data.type === 'visitor') successMsg = 'Visitor request has been submitted successfully.'
//     else if (data.type === 'checkinout') successMsg = 'Check In/Out request has been submitted successfully.'
//     else if (data.type === 'noticeperiod') successMsg = 'Your notice period request has been submitted successfully.'
    
//     setSuccessMessage(successMsg)
//     setShowSuccessModal(true)
//   }

//   const handleProfileUpdate = (updatedData) => {
//     updateTenantProfile(updatedData)
//     fetchActivities()
//   }

//   const handleLogoutClick = () => {
//     setShowLogoutModal(true)
//   }

//   const handleConfirmLogout = () => {
//     logout()
//     navigate('/')
//   }

//   const handleCancelLogout = () => {
//     setShowLogoutModal(false)
//   }

//   const handleAgreementClick = () => {
//     setModal('agreement')
//   }

//   const handleComingSoon = () => {
//     setShowComingSoon(true)
//   }

//   const ACTIVE_STATUSES = ['PENDING', 'OPEN', 'IN_PROGRESS']
//   const activeItems = activities.filter(a => ACTIVE_STATUSES.includes(a.status?.toUpperCase()))
//   const historyItems = activities.filter(a => !ACTIVE_STATUSES.includes(a.status?.toUpperCase()))

//   const byMonth = {}
//   historyItems.forEach(a => {
//     const month = getMonthYear(a.date)
//     if (!byMonth[month]) byMonth[month] = []
//     byMonth[month].push(a)
//   })
//   const sortedMonths = Object.keys(byMonth).sort((a, b) => new Date(b) - new Date(a))

//   const activeComplaintCount = activeItems.filter(a => a.type === 'complaint').length

//  if (loading) {
//   return (
//     <div className="td-root">
//       {/* Skeleton Navbar */}
//       <header className="td-navbar">
//             <div className="td-navbar-inner">
//               <button className="td-brand" onClick={() => navigate('/')}>
//                 <img src="/assets/AapkaPG-logo.svg" alt="KYS PG" className="od-navbar-logo" />
//               </button>

//               <div className="td-navbar-right">
//                 <div className="td-notif-wrap">
//                   <button className="td-bell-btn" onClick={() => setNotifOpen(p => !p)}>
//                     {Icon.bell}
//                   </button>
//                 </div>

//                 <button className="td-avatar-btn" onClick={() => setProfileOpen(true)}>
//                   {tenantInitials}
//                 </button>

//                 <button className="td-logout-btn" onClick={handleLogoutClick}>
//                   {Icon.logout}
//                 </button>
//               </div>
//             </div>
//           </header>

//       {/* Skeleton Hero */}
//       <div className="td-hero">
//         <div className="td-hero-inner">
//           <div>
//             <div className="td-hero-welcome-skeleton"></div>
//             <div className="td-hero-name-skeleton"></div>
//             <div className="td-hero-sub-skeleton"></div>
//           </div>
//           <div className="td-hero-avatar-skeleton"></div>
//         </div>
//       </div>

//       <main className="td-main">
//         <div className="td-container">
//           {/* Skeleton Stats */}
//           <div className="td-stats-grid">
//             {[1, 2, 3, 4].map((i) => (
//               <div key={i} className="td-stat-card-skeleton">
//                 <div className="td-stat-top-skeleton">
//                   <div className="td-stat-icon-skeleton"></div>
//                   <div className="td-stat-label-skeleton"></div>
//                 </div>
//                 <div className="td-stat-value-skeleton"></div>
//               </div>
//             ))}
//           </div>

//           {/* Skeleton Quick Actions */}
//           <div className="td-section">
//             <div className="td-section-title-skeleton"></div>
//             <div className="td-actions-grid">
//               {[1, 2, 3, 4].map((i) => (
//                 <div key={i} className="td-action-card-skeleton">
//                   <div className="td-action-icon-skeleton"></div>
//                   <div className="td-action-label-skeleton"></div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Skeleton Recent Activity */}
//           <div className="td-section">
//             <div className="td-section-title-skeleton"></div>
//             <div className="td-activity-list-skeleton">
//               {[1, 2, 3].map((i) => (
//                 <div key={i} className="td-activity-item-skeleton">
//                   <div className="td-activity-icon-skeleton"></div>
//                   <div className="td-activity-content-skeleton">
//                     <div className="td-activity-title-skeleton"></div>
//                     <div className="td-activity-meta-skeleton"></div>
//                   </div>
//                   <div className="td-activity-status-skeleton"></div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </main>

//       <style>{`
//         /* Skeleton Animations */
//         @keyframes td-shimmer {
//           0% {
//             background-position: -200px 0;
//           }
//           100% {
//             background-position: calc(200px + 100%) 0;
//           }
//         }

//         .td-shimmer {
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 8px;
//         }

//         /* Navbar Skeletons */
//         .td-brand-skeleton {
//           width: 120px;
//           height: 40px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 8px;
//         }

//         .td-bell-skeleton {
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 50%;
//         }

//         .td-avatar-skeleton {
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 50%;
//         }

//         .td-logout-skeleton {
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 8px;
//         }

//         /* Hero Skeletons */
//         .td-hero-welcome-skeleton {
//           width: 120px;
//           height: 18px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 4px;
//           margin-bottom: 8px;
//         }

//         .td-hero-name-skeleton {
//           width: 180px;
//           height: 32px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 4px;
//           margin-bottom: 8px;
//         }

//         .td-hero-sub-skeleton {
//           width: 150px;
//           height: 16px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 4px;
//         }

//         .td-hero-avatar-skeleton {
//           width: 64px;
//           height: 64px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 50%;
//         }

//         /* Stats Skeletons */
//         .td-stat-card-skeleton {
//           background: white;
//           border-radius: 12px;
//           padding: 20px;
//           box-shadow: 0 1px 3px rgba(0,0,0,0.06);
//           border: 1px solid #f3f4f6;
//         }

//         .td-stat-top-skeleton {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           margin-bottom: 12px;
//         }

//         .td-stat-icon-skeleton {
//           width: 32px;
//           height: 32px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 8px;
//         }

//         .td-stat-label-skeleton {
//           width: 80px;
//           height: 14px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 4px;
//         }

//         .td-stat-value-skeleton {
//           width: 100px;
//           height: 28px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 4px;
//         }

//         /* Quick Actions Skeletons */
//         .td-section-title-skeleton {
//           width: 160px;
//           height: 24px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 4px;
//           margin-bottom: 16px;
//         }

//         .td-action-card-skeleton {
//           background: white;
//           border-radius: 12px;
//           padding: 20px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//           border: 1px solid #f3f4f6;
//           min-height: 80px;
//           justify-content: center;
//         }

//         .td-action-icon-skeleton {
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 50%;
//         }

//         .td-action-label-skeleton {
//           width: 80px;
//           height: 14px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 4px;
//         }

//         /* Activity Skeletons */
//         .td-activity-list-skeleton {
//           background: white;
//           border-radius: 12px;
//           padding: 16px;
//           border: 1px solid #f3f4f6;
//         }

//         .td-activity-item-skeleton {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           padding: 12px 0;
//           border-bottom: 1px solid #f3f4f6;
//         }

//         .td-activity-item-skeleton:last-child {
//           border-bottom: none;
//         }

//         .td-activity-icon-skeleton {
//           width: 36px;
//           height: 36px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 50%;
//           flex-shrink: 0;
//         }

//         .td-activity-content-skeleton {
//           flex: 1;
//           display: flex;
//           flex-direction: column;
//           gap: 6px;
//         }

//         .td-activity-title-skeleton {
//           width: 60%;
//           height: 16px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 4px;
//         }

//         .td-activity-meta-skeleton {
//           width: 40%;
//           height: 12px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 4px;
//         }

//         .td-activity-status-skeleton {
//           width: 70px;
//           height: 24px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200px 100%;
//           animation: td-shimmer 1.5s infinite;
//           border-radius: 12px;
//           flex-shrink: 0;
//         }

//         /* Remove old spinner styles */
//         .td-loading {
//           display: block;
//           min-height: 100vh;
//           background: #F9FAFB;
//         }
//         .td-spinner {
//           display: none;
//         }
//       `}</style>
//     </div>
//   )
// }

//   return (
//     <div className="td-root">
//       {/* Modals */}
//       {profileOpen && (
//         <ProfileDrawer 
//           onClose={() => setProfileOpen(false)} 
//           onProfileUpdate={handleProfileUpdate}
//           tenantData={currentPG}
//         />
//       )}
        
//       {modal === 'complaint' && (
//         <ComplaintModal
//           onClose={() => setModal(null)}
//           onSubmit={handleActivitySubmit}
//           tenantId={tenantId}
//           pgId={pgId}
//           currentPG={currentPG}
//         />
//       )}
//       {modal === 'checkinout' && (
//         <CheckInOutModal
//           onClose={() => setModal(null)}
//           onSubmit={handleActivitySubmit}
//           tenantId={tenantId}
//           pgId={pgId}
//           currentPG={currentPG}
//         />
//       )}
//       {modal === 'visitor' && (
//         <VisitorModal
//           onClose={() => setModal(null)}
//           onSubmit={handleActivitySubmit}
//           tenantId={tenantId}
//           pgId={pgId}
//           currentPG={currentPG}
//         />
//       )}
//       {modal === 'agreement' && (
//         <AgreementModal 
//           onClose={() => setModal(null)} 
//           onComingSoon={handleComingSoon}
//           currentPG={currentPG}
//         />
//       )}
//       {modal === 'noticeperiod' && (
//         <NoticePeriodModal
//           onClose={() => setModal(null)}
//           onSubmit={handleActivitySubmit}
//           tenantId={tenantId}
//           pgId={pgId}
//           currentPG={currentPG}
//         />
//       )}

//       {showLogoutModal && (
//         <LogoutConfirmationModal 
//           onClose={handleCancelLogout} 
//           onConfirm={handleConfirmLogout} 
//         />
//       )}

//       {showNoPGWarning && userDataList.length === 0 && (
//         <NoPGLinkedModal onClose={() => {
//           handleConfirmLogout()
//           setShowNoPGWarning(false)
//         }} />
//       )}

//       <SuccessModal 
//         isOpen={showSuccessModal}
//         onClose={() => setShowSuccessModal(false)}
//         title="Success!"
//         message={successMessage}
//       />

//       <ErrorModal 
//         isOpen={showErrorModal}
//         onClose={() => setShowErrorModal(false)}
//         title="Error"
//         message={errorMessage}
//       />

//       <ComingSoonModal 
//         isOpen={showComingSoon}
//         onClose={() => setShowComingSoon(false)}
//       />

//       {foodMenuOpen && (
//         <FoodMenuModal
//           isOpen={foodMenuOpen}
//           onClose={() => setFoodMenuOpen(false)}
//           selectedPG={currentPG}
//         />
//       )}


//       {!hasNoPG ? (
//         <>
//           <header className="td-navbar">
//             <div className="td-navbar-inner">
//               <button className="td-brand" onClick={() => navigate('/')}>
//                 <img src="/assets/AapkaPG-logo.svg" alt="KYS PG" className="od-navbar-logo" />
//               </button>

//               <div className="td-navbar-right">
//                 <div className="td-notif-wrap">
//                   <button className="td-bell-btn" onClick={() => setNotifOpen(p => !p)}>
//                     {Icon.bell}
//                   </button>
//                 </div>

//                 <button className="td-avatar-btn" onClick={() => setProfileOpen(true)}>
//                   {tenantInitials}
//                 </button>

//                 <button className="td-logout-btn" onClick={handleLogoutClick}>
//                   {Icon.logout}
//                 </button>
//               </div>
//             </div>
//           </header>

//           <div className="td-hero">
//             <div className="td-hero-inner">
//               <div>
//                 <p className="td-hero-welcome">Welcome back,</p>
//                 <h1 className="td-hero-name">{tenantName}</h1>
//                 <p className="td-hero-sub">{roomDisplay}</p>
//               </div>
//               <div className="td-hero-right">
//                 {tenantPGs.length > 0 && (
//                   <div className="td-pg-dropdown-wrap">
//                     <select 
//                       className="td-pg-dropdown"
//                       value={selectedPGIndex}
//                       onChange={(e) => setSelectedPGIndex(parseInt(e.target.value))}
//                     >
//                       {tenantPGs.map((pg, index) => (
//                         <option key={index} value={index}>
//                           {pg.PGName || `PG #${pg.PGID}`} ({pg.PGCode || '—'})
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 )}
//                 <div className="td-hero-avatar">{tenantInitials}</div>
//               </div>
//             </div>
//           </div>

//           <main className="td-main">
//             <div className="td-container">
//               <div className="td-stats-grid">
//                 <StatCard icon={Icon.rupee} label="Rent Due" value={`₹${rentAmount.toLocaleString() || '0'}`} valueClass="td-stat-amber" />
//                 <StatCard icon={Icon.calendar} label="Due Date" value={currentPG.DueDate ? formatDate(currentPG.DueDate) : '—'} />
//                 <StatCard icon={Icon.chat} label="Active Complaints" value={String(activeComplaintCount)} valueClass="td-stat-amber" />
//                 <StatCard icon={Icon.bell} label="Total Activities" value={String(activities.length)} valueClass="td-stat-indigo" />
//               </div>

//               <div className="td-section">
//                 <h2 className="td-section-title">Quick Actions</h2>
//                 <div className="td-actions-grid">
//                   <ActionCard icon={Icon.complaint} label="Raise Complaint" color="#EF4444" bg="#FFF1F2" onClick={() => setModal('complaint')} />
//                   <ActionCard icon={Icon.calendar} label="Schedule Check In/Out" color="#EF4444" bg="#FFF1F2" onClick={() => setModal('checkinout')} />
//                   <ActionCard icon={Icon.visitor} label="Add Visitor" color="#EF4444" bg="#FFF1F2" onClick={() => setModal('visitor')} />
//                   <ActionCard icon={Icon.doc} label="View Agreement" color="#EF4444" bg="#FFF1F2" onClick={handleAgreementClick} />                
//                   <ActionCard
//                     icon={
//                       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
//                         <path d="M7 2v5H6V2H5v5H4V2H3v5c0 1.93 1.28 3.55 3 4.07V22h1v-10.93c1.72-.52 3-2.14 3-4.07V2H9v5H8V2H7z" />
//                         <path d="M17 2c-1.38 0-2.5 1.12-2.5 2.5v7.5c0 .55.45 1 1 1h1.5V22h1V2s-1-.03-1 0z" />
//                       </svg>
//                     }
//                     label="Food Menu"
//                     color="#EF4444"
//                     bg="#FFF1F2"
//                     onClick={() => setFoodMenuOpen(true)}
//                   />
//                   <ActionCard icon={Icon.calendar} label="Notice Period" color="#EF4444" bg="#FFF1F2" onClick={() => setModal('noticeperiod')} />
//                 </div>
//               </div>

//               <div className="td-section">
//                 <h2 className="td-section-title">Recent Activity</h2>

//                 {activeItems.length > 0 && (
//                   <div className="td-active-strip">
//                     <div className="td-active-strip-head">
//                       <span className="td-active-strip-label">Active</span>
//                       <span className="td-active-badge">{activeItems.length}</span>
//                     </div>
//                     {activeItems.map((a, idx) => (
//                       <div key={idx} className="td-act-row">
//                         <ActivityIcon type={a.type} />
//                         <div className="td-act-info">
//                           <span className="td-act-title">{a.title}</span>
//                           <span className="td-act-meta">
//                             <span className="td-act-type-pill" style={{ color: TYPE_CFG[a.type]?.color, background: TYPE_CFG[a.type]?.bg }}>
//                               {TYPE_CFG[a.type]?.label}
//                             </span>
//                             · {a.sub} · {formatDate(a.date)}
//                           </span>
//                         </div>
//                         <StatusBadge status={a.status} />
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {sortedMonths.length > 0 && (
//                   <div className="td-acc-list">
//                     {sortedMonths.map(month => (
//                       <ActivityAccordion
//                         key={month}
//                         month={month}
//                         items={byMonth[month]}
//                         defaultOpen={false}
//                       />
//                     ))}
//                   </div>
//                 )}

//                 {activities.length === 0 && (
//                   <div className="td-empty-state">
//                     <p>No activities yet. Use quick actions to get started!</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </main>
//         </>
//       ) : null}

//       <style>{`
//         .td-loading {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           min-height: 100vh;
//           background: #F9FAFB;
//         }
//         .td-spinner {
//           width: 40px;
//           height: 40px;
//           border: 3px solid #E5E7EB;
//           border-top-color: #6366F1;
//           border-radius: 50%;
//           animation: td-spin 0.8s linear infinite;
//           margin-bottom: 16px;
//         }
//         @keyframes td-spin {
//           to { transform: rotate(360deg); }
//         }
//         .td-empty-state {
//           text-align: center;
//           padding: 48px 20px;
//           background: #F9FAFB;
//           border-radius: 12px;
//           color: #6B7280;
//         }
//         .td-no-pg-icon-wrapper {
//           width: 64px;
//           height: 64px;
//           background: #FEF3C7;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto;
//           color: #D97706;
//         }
//         .td-logout-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(0, 0, 0, 0.5);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1000;
//           animation: td-fadeIn 0.2s ease-out;
//         }
//         @keyframes td-fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         .td-logout-modal {
//           background: white;
//           border-radius: 20px;
//           width: 90%;
//           max-width: 400px;
//           box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
//           animation: td-slideUp 0.3s ease-out;
//         }
//         @keyframes td-slideUp {
//           from { transform: translateY(20px); opacity: 0; }
//           to { transform: translateY(0); opacity: 1; }
//         }
//         .td-logout-modal-header { padding: 24px 24px 0 24px; text-align: center; }
//         .td-logout-icon-wrapper {
//           width: 64px; height: 64px; background: #FEF2F2; border-radius: 50%;
//           display: flex; align-items: center; justify-content: center; margin: 0 auto; color: #DC2626;
//         }
//         .td-logout-modal-body { padding: 20px 24px; text-align: center; }
//         .td-logout-modal-title { font-size: 20px; font-weight: 600; color: #1F2937; margin-bottom: 8px; }
//         .td-logout-modal-message { font-size: 14px; color: #6B7280; line-height: 1.5; }
//         .td-logout-modal-footer { padding: 16px 24px 24px 24px; display: flex; gap: 12px; }
//         .td-logout-btn-cancel, .td-logout-btn-confirm {
//           flex: 1; padding: 10px 16px; border-radius: 10px; font-size: 14px;
//           font-weight: 500; cursor: pointer; transition: all 0.2s; border: none;
//         }
//         .td-logout-btn-cancel { background: #F3F4F6; color: #4B5563; }
//         .td-logout-btn-cancel:hover { background: #E5E7EB; }
//         .td-logout-btn-confirm { background: #DC2626; color: white; }
//         .td-logout-btn-confirm:hover { background: #B91C1C; }
        
//         .td-input-err { border-color: #EF4444 !important; background-color: #FEF2F2 !important; }
//         .td-hint { font-size: 11px; color: #9CA3AF; margin-top: 2px; }

//         .td-hero-right {
//           display: flex;
//           align-items: center;
//           gap: 16px;
//         }

//         .td-pg-dropdown-wrap {
//           display: flex;
//           align-items: center;
//         }

//         .td-pg-dropdown {
//           padding: 8px 12px;
//           border-radius: 8px;
//           border: 1px solid #E5E7EB;
//           background: white;
//           font-size: 14px;
//           font-weight: 500;
//           color: #1F2937;
//           cursor: pointer;
//           outline: none;
//           transition: all 0.2s;
//           min-width: 180px;
//         }

//         .td-pg-dropdown:hover {
//           border-color: #F06E18;
//         }

//         .td-pg-dropdown:focus {
//           border-color: #F06E18;
//           box-shadow: 0 0 0 3px rgba(240, 110, 24, 0.1);
//         }
//       `}</style>
//     </div>
//   )
// }

// export default TenantDashboard